/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { toast } from 'react-toastify';
import NumberFormat from 'react-number-format';
import RadioButton from 'carbon-components-react/lib/components/RadioButton';
import StarRatings from 'react-star-ratings';
import {
  DataTable,
  TextInput,
  FormItem,
  TextArea,
  Modal,
  Notification
} from 'carbon-components-react';
import { Link } from 'react-router-dom';
import ButtonLink from '../../ButtonLink';
import { Breadcrumb, SearchInput, Card } from '../../index';
import DatePickerDm from '../../DatePicker';
import OrderHistory from './OrderHistory';
import {
  getByDmService,
  insertDmService,
  pathDmService,
  deleteDmService,
  updateDmService,
  getDmService
} from '../../../services/Api';
import appConfig from '../../../config/app-config';
import ModalDm from '../../Modal/ModalDm';
import ModalLogistica from '../../Modal/ModalLogistica';
import ModalConfirmacao from '../../Modal/ModalConfirmacao';
import unitsOfmeasurement from '../../../fixtures/unitsOfmeasurement.json'
import { Administrador, GerenteComercial, Consultor, Interno, Supervisor, Criacao } from '../../../config/UserStatusLevel';
import {
  AguardandoProducao,
  AmostraDeCartao,
  AprovacaoComercial,
  AprovacaoDeArte,
  Cancelado,
  Criacao as StatusCriacao,
  Redatora as StatusRedacao,
  Devolvido,
  DisponivelParaRetirada,
  EmTransporte,
  FechamentoDeArquivo,
  Finalizado,
  Fornecedor,
  Redatora,
  RevisaoInterna,
  Triagem,
  Orcamento,
  SupervisaoTrade,
  Supervisao,
  // AprovacaoDeRedacao
} from '../../../config/StatusPedido';

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableSelectRow,
  TableBody,
  TableCell,
  TableHeader
} = DataTable;
const { IMAGE_PATH } = appConfig;

class DetailRequestAgency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openCustoAdicional: false,
      openTrocaDeStatus: false,
      openModalFornecedor: false,
      openModalResponsavel: false,
      openModalCancelar: false,
      openModalReprovar: false,
      openModalEmTransporte: false,
      openModalFinalizarPedido: false,
      openModalLogistica: false,
      openModalConfirmacao: false,
      openRatingModal: false,
      newStatusModalConfirmacao: 0,
      modalLojas: false,
      data: null,
      idItem: 0,
      listDesigners: [],
      listRedatora: [],
      listPrioridades: [],
      prioridades: [],
      search: "",
      exibirdataStatusItem: false,
      exibeDescricao: false,
      idTagPreco: [],
      openMdOrcar: false,
      openMdDelete: false,
      nomeUnidadeMedida: "",
      motivoExcluir: "",
      openMdEquipe: false,
      openMdSolicitante: false,
      solicitantes: [],
      idSolicitante: 0,
      searchSolicitante: "",
      equipes: [],
      idEquipe: 0,
      idsRequests: [],
      width: 0,
      notaCriacao: 0,
      notaCriacaoComentario: "",
      notaMaterial: 0,
      notaMaterialComentario: "",
      notaAtendimento: 0,
      notaAtendimentoComentario: "",
      logistica: null,
      listaSolicitanteComercial: ["Aline Reis", "Maicon Zaniboni"],
      openTracking: false,
    };
  }

  componentWillMount = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel });

    const prioridades = [{ label: "Alto", id: 1 }, { label: "Baixo", id: 2 }, { label: "Medio", id: 3 }];
    this.setState({ prioridades });
    await this.load();
    if (nivel === Administrador) {
      await this.loadFornecedor();
      await this.loadEstado();
      await this.loadDesigners();
      await this.loadSolicitante();
      await this.loadLogistica();
      await this.loadRedatora();
      await this.loadPrioridade();
    }
    if (nivel === Interno) {
      await this.loadLogistica();
    }
    await this.getEquipes()
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    // console.log('solicitante')
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  load = async () => {
    try {
      const { match } = this.props;
      const data = await getByDmService('/Pedido/GetAgenciaAtendente', `${match.params.id}`);
      this.setState({ idsRequests: [data.id] })
      const { unidades } = await data;
      const unidadesIds = await unidades.map(item => item.unidade.id).filter((value, index, self) => self.indexOf(value) === index);
      const orcamentoObrigatorio = await data.itensAgencia.resultado.filter(item => !item.excluido && item.valorUnitarioFormatado === "Orçamento Obrigatório");
      const existOrcamentoObrigatorio = !!orcamentoObrigatorio.length;
      await this.setState({ data, unidadesIds, existOrcamentoObrigatorio });
    } catch (error) {
      console.error(error);
    }
  }

  loadFornecedor = async () => {
    try {
      const { search, estadoId, cidadeId, idTagPreco, grupos } = this.state;
      const data = await getByDmService('/Fornecedor/Busca', `?tagspreco=${idTagPreco.join(",")}&grupos=${grupos ? grupos.join(",") : ""}&estado=${estadoId ? estadoId.id : ""}&cidade=${cidadeId ? cidadeId.id : ""}&pesquisa=${search}`);
      this.setState({ fornecedores: data });
    } catch (error) {
      console.error(error);
    }
  }

  loadEstado = async () => {
    try {
      const data = await getByDmService('/Estado/Get', `?fornecedor=true`);
      const estados = data.map(item => ({ id: item.id, label: item.sigla }));
      await this.setState({ estados });
      this.loadFornecedor()
    } catch (error) {
      console.error(error);
    }
  }

  loadCidades = async () => {
    try {
      const { estadoId } = this.state;
      if (estadoId) {
        const data = await getByDmService('/Cidade/GetByEstado/', `${estadoId.id}?fornecedor=true`);
        const cidades = data.map(item => ({ id: item.id, label: item.nome }));
        await this.setState({ cidades });
        this.loadFornecedor()
      } else {
        this.setState({ cidades: [] });
      }
    } catch (error) {
      console.error(error);
    }
  }

  loadLogistica = async () => {
    try {
      const { data } = this.state;
      if (data.logistica) {
        const dados = await getByDmService('/Pedido/GetDadosLogistica/', data.id);
        this.setState({ logistica: dados });
      }
    } catch (error) {
      console.error(error);
    }
  }

  loadRedatora = async () => {
    const optionsRedatora = [{ id: 0, label: "Não" }, { id: 1, label: "Sim" }];
    this.setState({ listRedatora: optionsRedatora });
  }

    loadPrioridade = async () => {
    const optionsPrioridade = [{ id: 0, label: "Indefinido" }, { id: 1, label: "Alto" }, { id: 2, label: "Baixo" }, { id: 3, label: "Médio" }];
    this.setState({ listPrioridades: optionsPrioridade });
  }

  onSearchChange = async (e) => {
    await this.setState({ search: e.target.value });
    this.loadFornecedor()
  }

  loadDesigners = async () => {
    try {
      const data = await getDmService("/Usuario/GetDesigners")
      const list = data.map(item => ({ id: item.id, label: item.nome }));
      this.setState({ listDesigners: list });
    } catch (error) {
      console.error(error);
    }
  }

  salvaNovaData = async () => {
    const { novaDataDesejada } = this.state;
    const { match } = this.props;

    if (!novaDataDesejada) {
      toast.warn("Informe a data desejada")
    } else {
      try {
        const obj = {
          "lst": [
            {
              "IdPedido": match.params.id,
              "DataDesejada": novaDataDesejada
            }
          ]
        }
        await insertDmService('/Pedido/UpdateDataDesejada', obj);

        toast.success('Dados atualizados com sucesso');
        this.load();
        this.toggleModal('openModalNovaDataDesejada')
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  delegaDesigner = async () => {
    const { idDesigner, dataEstimada, isRedatora, StatusRedacao, StatusCriacao, isPrioridade } = this.state;
    const { match } = this.props;

    if (!dataEstimada) {
      toast.warn("Informe a data estimada")
    } else if (!idDesigner) {
      toast.warn("Informe o responsável")
    } else if (!isRedatora) {
      toast.warn("Informe se haverá Redatora no pedido")
    } else {
      try {
        const obj = {
          "lst": [
            {
              "IdPedido": match.params.id,
              "IdDesigner": idDesigner.id,
              "isRedatora": isRedatora.id,
              "DataEstimada": dataEstimada,
              "Redacao": StatusRedacao,
              "Criacao": StatusCriacao,
              "Prioridade": isPrioridade.id
            }
          ]
        }
        await insertDmService('/Pedido/DelegaDesigner', obj);

        toast.success('Dados atualizados com sucesso');
        this.load();
        this.toggleModal('openModalResponsavel')
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  delegaFornecedor = async () => {
    const { idFornecedor, idsItemPedido, dataEstimativaEntrega, idItemPedido } = this.state;

    if (!dataEstimativaEntrega) {
      toast.warn("Informe a data estimada")
    } else if (!idFornecedor) {
      toast.warn("Selecione o fornecedor")
    } else {
      try {
        const dataRequest = moment(dataEstimativaEntrega).format("MM-DD-YYYY")
        if (idsItemPedido.length > 0) {
          for (const item of idsItemPedido) {
            // eslint-disable-next-line no-await-in-loop
            await insertDmService('/Pedido/DelegaFornecedor', {"IdItemPedido": item, "IdFornecedor": idFornecedor, "DataEstimadaEntrega": dataRequest});
          }
        } else {
          await insertDmService('/Pedido/DelegaFornecedor', {
            "IdItemPedido": idItemPedido,
            "IdFornecedor": idFornecedor,
            "DataEstimadaEntrega": dataRequest
          });
        }
        toast.success('Dados atualizados com sucesso');
        await this.load();
        this.toggleModal('openModalFornecedor')
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  goUrl = () => {
    const { history } = this.props;
    const { nivel } = this.state;
    const showAdminMenu = JSON.parse(localStorage.getItem('showAdminMenu')) || false;
    let urlGo = '/admin/agencia/pedidos';
    if ([GerenteComercial, Criacao, Administrador].indexOf(nivel) === -1 || (nivel === Administrador && showAdminMenu === false))
      urlGo = "/pedidos/agencia";
    history.push(urlGo);
  };

  goEdit = (id) => {
    const { history } = this.props;
    const idRequest = id;
    history.push(`/agencia/pedido/${idRequest}`);
  }

  cancelarItem = async () => {
    this.setState({
      idStatus: Cancelado,
      mensagemSucesso: 'Pedidos cancelado com sucesso',
      modal: 'openModalCancelar',
      nomeAcao: "Cancelar",
      openModalCancelar: true
    })
  }

  aprovacaoComercial = async () => {
    this.setState({
      idStatus: AprovacaoComercial,
      mensagemSucesso: 'Pedido enviado com sucesso',
      nomeAcao: "Aprovar Comercialmente",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  revisaoInterna = async () => {
    this.setState({
      idStatus: RevisaoInterna,
      mensagemSucesso: 'Pedido enviado para revisão interna',
      nomeAcao: "Enviar para Revisão interna",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  supervisaoTrade = async () => {
    this.setState({
      idStatus: SupervisaoTrade,
      mensagemSucesso: 'Pedido enviado para supervisão trade',
      nomeAcao: "Enviar para Supervisão Trade",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }
  
    supervisao = async () => {
    this.setState({
      idStatus: Supervisao,
      mensagemSucesso: 'Pedido enviado para supervisão',
      nomeAcao: "Enviar para Supervisão",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  devolverCriacao = async () => {
    this.setState({
      idStatus: 14,
      mensagemSucesso: 'Pedido retornou para Criação',
      nomeAcao: "Devolver",
      motivoDevolver: "",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  devolverItem = async () => {
    const { nivel } = this.state;
    this.setState({
      idStatus: nivel === Criacao ? Triagem : Devolvido,
      mensagemSucesso: 'Pedido devolvido com sucesso',
      nomeAcao: "Devolver",
      motivoDevolver: "",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

// Assumindo que 'toast' está disponível globalmente ou via import/context.
// Exemplo de import (se estiver usando uma biblioteca como react-toastify):
// import { toast } from 'react-toastify';

devolverStatusAnterior = async (statusId) => {
    let previousStatusId = null;
    let errorMessage = null;

    // Mapeamento dos nomes dos status para os IDs.
    // **IMPORTANTE**: Substitua estes IDs pelos IDs reais do seu sistema.
    const statusMap = {
        "Triagem": 16, // Exemplo de ID
        "Supervisão Trade": 32, // Exemplo de ID
        "Devolv": 4, // Exemplo de ID (assumindo que "Devolv" é o ID 4 do seu switch original)
        "Redação": 30, // Exemplo de ID
        "Criação": 14, // Exemplo de ID
        "Revisão interna": 18, // Exemplo de ID
        "Supervisão": 28, // Exemplo de ID
        "Aprov. Arte": 19, // Exemplo de ID
        "Fechto Arquivo": 20, // Exemplo de ID
        "Orçamento": 31, // Exemplo de ID
        "Aguard. Produção": 21, // Exemplo de ID
        "Fornecedor": 22, // Exemplo de ID
        "Disp. Retirada": 23, // Exemplo de ID
        "Finalizado": 25, // Exemplo de ID
        // Adicione outros status do seu switch original aqui se forem relevantes para o fluxo de retorno
    };

    // --- Lógica para determinar 'hasText' e 'isDigital' ---

    // Para 'hasText': Verificar se algum item em itensAgencia.resultado tem 'criarTextoRedacao' como true.
    // Assumindo que 'itensAgencia' é uma propriedade do 'this.state'.
    let hasText = false;
    if (this.state.itensAgencia && this.state.itensAgencia.resultado && this.state.itensAgencia.resultado.length > 0) {
        hasText = this.state.itensAgencia.resultado.some(item => item.criarTextoRedacao === true);
    } else {
        console.warn("`this.state.itensAgencia.resultado` não encontrado ou vazio. Assumindo `hasText = false` para a lógica de devolução.");
    }

    // Para 'isDigital': Usando o método existente this.isProdutoDigital(), conforme o exemplo que você forneceu.
    // Este método já tem acesso ao 'this.state.data' e retorna um booleano.
    let isDigital = false;
    if (typeof this.isProdutoDigital === 'function') {
        isDigital = this.isProdutoDigital();
    } else {
        // Se o método não for encontrado, isso é um erro crítico para a lógica de "Finalizado".
        errorMessage = "O método `this.isProdutoDigital()` não foi encontrado ou não é uma função. Não é possível determinar se o produto é digital para a etapa 'Finalizado'.";
        console.error(errorMessage);
    }

    // --- Fim da lógica para determinar 'hasText' e 'isDigital' ---

    // Se já houver um errorMessage devido à falta de isProdutoDigital, não prossegue com o switch
    if (!errorMessage) {
        switch (statusId) {
            case statusMap["Triagem"]:
                errorMessage = "O item na etapa 'Triagem' não pode ser devolvido, pois é o status inicial.";
                break;
            case statusMap["Supervisão Trade"]:
                previousStatusId = statusMap["Triagem"];
                break;
            case statusMap["Devolv"]:
                errorMessage = "O item na etapa 'Devolv' não pode ser devolvido.";
                break;
            case statusMap["Redação"]:
                previousStatusId = statusMap["Triagem"];
                break;
            case statusMap["Criação"]:
                if (hasText) {
                    previousStatusId = statusMap["Redação"];
                } else {
                    previousStatusId = statusMap["Triagem"];
                }
                break;
            case statusMap["Revisão interna"]:
                previousStatusId = statusMap["Criação"];
                break;
            case statusMap["Supervisão"]:
                previousStatusId = statusMap["Supervisão"]; // Retorna para si mesma, conforme a regra
                break;
            case statusMap["Aprov. Arte"]:
                previousStatusId = statusMap["Supervisão"];
                break;
            case statusMap["Fechto Arquivo"]:
                previousStatusId = statusMap["Aprov. Arte"];
                break;
            case statusMap["Orçamento"]:
                previousStatusId = statusMap["Fechto Arquivo"];
                break;
            case statusMap["Aguard. Produção"]:
                previousStatusId = statusMap["Orçamento"];
                break;
            case statusMap["Fornecedor"]:
                previousStatusId = statusMap["Aguard. Produção"];
                break;
            case statusMap["Disp. Retirada"]:
                previousStatusId = statusMap["Fornecedor"];
                break;
            case statusMap["Finalizado"]:
                // A condição "se for digital" agora usa a variável `isDigital` corretamente determinada por `this.isProdutoDigital()`.
                if (isDigital) {
                    previousStatusId = statusMap["Fechto Arquivo"];
                } else {
                    previousStatusId = statusMap["Disp. Retirada"];
                }
                break;
            default:
                errorMessage = `O status ID ${statusId} não possui uma regra de retorno definida ou é inválido.`;
                break;
        }
    }


    if (errorMessage) {
        // Usa toast.warn() para exibir a mensagem de erro
        if (typeof toast !== 'undefined' && toast.warn) {
            toast.warn(errorMessage);
        } else {
            console.warn("`toast.warn` não está disponível. Exibindo erro no console:", errorMessage);
        }

        // Atualiza o estado para refletir o erro, sem mudar o idStatus
        this.setState({
            mensagemErro: errorMessage,
            mensagemSucesso: '', // Limpa a mensagem de sucesso
            nomeAcao: "Devolver",
            motivoDevolver: "",
            modal: '', // Não abre modal de sucesso/cancelar
            openModalCancelar: false,
            // Se você tiver um modal específico para erros, pode ativá-lo aqui
            // openModalErro: true
        });
    } else {
        // Se não houver erro, atualiza o estado com o novo ID do status e a mensagem de sucesso.
        this.setState({
            idStatus: previousStatusId,
            mensagemSucesso: 'Pedido devolvido com sucesso',
            nomeAcao: "Devolver",
            motivoDevolver: "",
            modal: 'openModalCancelar',
            openModalCancelar: true,
            mensagemErro: '' // Limpa qualquer mensagem de erro anterior
        });
    }
};


  atualizarParaEntregueModal = () => {
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.ids.length > 0) {
      this.setState({ openModalFinalizarPedido: true })
    } else {
      toast.warn("Selecione algo");
    }
  }

  disponivelParaRetirada = async () => {
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.ids.length > 0) {
      this.setState({
        idStatus: DisponivelParaRetirada,
        mensagemSucesso: 'Item atualizado com sucesso',
        nomeAcao: "Disponibilizar para retirada",
        motivoDevolver: "",
        modal: 'openModalCancelar',
        openModalCancelar: true
      })
    } else {
      toast.warn("Selecione algo");
    }
  }

  emTransporte = async () => {
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.ids.length > 0) {
      this.setState({
        idStatus: EmTransporte,
        mensagemSucesso: 'Item atualizado com sucesso',
        nomeAcao: "Atualizar para 'Em transporte'",
        modal: 'openModalEmTransporte',
        openModalEmTransporte: true
      })
    } else {
      toast.warn("Selecione algo");
    }
  }

  pedidoEntrege = async () => {
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.ids.length > 0) {
      this.setState({
        idStatus: Finalizado,
        mensagemSucesso: 'Item atualizado com sucesso',
        nomeAcao: "Atualizar para 'Pedido Entregue'",
        modal: 'openModalCancelar',
        openModalCancelar: true
      })
    } else {
      toast.warn("Selecione algo");
    }
  }

  retornaFornecedor = async () => {
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.ids.length > 0) {
      this.setState({
        idStatus: Fornecedor,
        mensagemSucesso: 'Item atualizado com sucesso',
        nomeAcao: "Retornar para Fornecedor",
        modal: 'openModalCancelar',
        openModalCancelar: true
      })
    } else {
      toast.warn("Selecione algo");
    }
  }

  aprovarPedido = async () => {
    this.setState({
      idStatus: AprovacaoDeArte,
      mensagemSucesso: 'Pedido aprovado com sucesso',
      nomeAcao: "Aprovar",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  aprovacaoDeArte = async () => {
    this.setState({
      idStatus: FechamentoDeArquivo,
      mensagemSucesso: 'Pedido aprovado com sucesso',
      nomeAcao: "Aprovar",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  // aprovacaoDeRedacao = async () => {
  //   this.setState({
  //     idStatus: Criacao,
  //     mensagemSucesso: 'Pedido aprovado com sucesso',
  //     nomeAcao: "Aprovar",
  //     modal: 'openModalCancelar',
  //     openModalCancelar: true
  //   })
  // }

  finalizar = async () => {
    this.setState({
      idStatus: Finalizado,
      mensagemSucesso: 'Pedido finalizado com sucesso',
      nomeAcao: "Finalizar",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  concluirPedido = async () => {
    this.setState({
      idStatus: Orcamento,
      mensagemSucesso: 'Pedido concluído com sucesso',
      nomeAcao: "Concluir",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  reprovarProducao = async () => {
    this.setState({
      idStatus: FechamentoDeArquivo,
      mensagemSucesso: 'Pedido reprovado com sucesso',
      nomeAcao: "Reprovar",
      modal: 'openModalCancelar',
      openModalCancelar: true,
      motivoDevolver: ""
    })
  }

  reprovarArte = async () => {
    this.setState({
      idStatus: StatusCriacao,
      mensagemSucesso: 'Pedido reprovado com sucesso',
      nomeAcao: "Reprovar",
      modal: 'openModalCancelar',
      openModalCancelar: true,
      motivoDevolver: ""
    })
  }

  reprovarRedacao = async () => {
    this.setState({
      idStatus: StatusRedacao,
      mensagemSucesso: 'Pedido reprovado com sucesso',
      nomeAcao: "Reprovar",
      modal: 'openModalCancelar',
      openModalCancelar: true,
      motivoDevolver: ""
    })
  }

  reprovarComercialmente = async () => {
    this.setState({
      idStatus: Devolvido,
      mensagemSucesso: 'Pedido reprovado com sucesso',
      nomeAcao: "Reprovação comercial",
      modal: 'openModalCancelar',
      openModalCancelar: true,
      motivoDevolver: ""
    })
  }

  aprovacaoDoComercial = async () => {
    this.setState({
      idStatus: Triagem,
      mensagemSucesso: 'Pedido aprovado com sucesso',
      nomeAcao: "Aprovar",
      modal: 'openModalCancelar',
      openModalCancelar: true,
    })
  }
  
  enviarTriagem = async () => {
    this.setState({
      idStatus: Triagem,
      mensagemSucesso: 'Pedido retornou para Triagem',
      nomeAcao: "Enviar para Triagem",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  enviarParaCriacao = async () => {
    this.setState({
      idStatus: StatusCriacao,
      mensagemSucesso: 'Pedido enviado para criação',
      nomeAcao: "Enviar para Criação",
      modal: 'openModalCancelar',
      openModalCancelar: true
    })
  }

  concluirConsultor = async () => {
    this.setState({
      idStatus: Triagem,
      mensagemSucesso: 'Pedido atualizado com sucesso',
      nomeAcao: "Concluir",
      modal: 'openModalCancelar',
      openModalCancelar: true,
    })
  }

  enviarParaAguardProd = async () => {
    this.setState({
      idStatus: AguardandoProducao,
      mensagemSucesso: 'Pedido enviado para aguardando produção com sucesso',
      nomeAcao: "Enviar para Produção",
      modal: 'openModalCancelar',
      openModalCancelar: true,
    })
  }

  reprovarPedido = async () => {
    const { novaDataEstimada } = this.state;
    const { match } = this.props;

    if (!novaDataEstimada) {
      toast.warn("Informe a nova data");
      return;
    }

    try {

      const dataRequest = moment(novaDataEstimada).format("MM-DD-YYYY");
      const obj = { "DataEstimada": dataRequest }

      await updateDmService('/Pedido/Reprova', match.params.id, obj);

      toast.success("Pedido reprovado com sucesso");
      this.load();
      this.toggleModal("openModalReprovar")
    } catch (e) {
      this.errorHandler(e);
    }
  }

  trocaStatusPedidoEntregue = async () => {
    const { selectedRows, responsavelRecebimento, responsavelEntrega, diaEntrega } = this.state;
    try {
      if (!responsavelEntrega) {
        toast.warn("Informe o nome do responsável pela entrega");
        return;
      }

      if (!diaEntrega) {
        toast.warn("Informe a data de chegada");
        return;
      }

      if (!responsavelRecebimento) {
        toast.warn("Informe o nome do responsável pelo recebimento");
        return;
      }

      const obj = {
        "status": Finalizado,
        responsavelRecebimento,
        responsavelEntrega,
        dataEntregaFornecedor: moment(diaEntrega).format("MM-DD-YYYY"),
        lstIdItemPedido: selectedRows.ids
      };

      await updateDmService('/Pedido/AtualizaStatusItemPedidoAgencia', "", obj);
      this.setState({ motivoDevolver: "" })
      this.toggleModal("openModalFinalizarPedido");
      toast.success(selectedRows.ids > 1 ? "Itens atualizados com sucesso" : "Item atualizado com sucesso");
      this.load();

    } catch (e) {
      this.errorHandler(e);
    }
  }

  trocaStatusTransporte = async () => {
    try {
      const { idStatus, selectedRows, diaEntrega, nomeTransportadora } = this.state;
      if (!diaEntrega) {
        toast.warn("Informe o dia da entrega");
        return;
      }

      if (!nomeTransportadora) {
        toast.warn("Informe o nome da transportadora");
        return;
      }

      const obj = {
        "status": idStatus,
        nomeTransportadora,
        lstIdItemPedido: selectedRows.ids
      }

      obj.dataEntregaFornecedor = moment(diaEntrega).toISOString();
      await updateDmService('/Pedido/AtualizaStatusItemPedidoAgencia', "", obj);

      this.toggleModal("openModalEmTransporte");
      toast.success(selectedRows.ids > 1 ? "Itens atualizados com sucesso" : "Item atualizado com sucesso");
      this.load();

    } catch (e) {
      this.errorHandler(e);
    }
  }

  trocaStatus = async () => {
    const {
      idStatus,
      responsavelRecebimento,
      mensagemSucesso,
      modal,
      motivoDevolver,
      ocorrenciaFechamentoArquivo,
      nivel,
      selectedRows,
      diaEntrega,
      nomeAcao,
      data
    } = this.state;
    try {
      const { match } = this.props;
      if (([Devolvido, Cancelado, Fornecedor, StatusCriacao].indexOf(idStatus) > -1 || ([DisponivelParaRetirada].indexOf(idStatus) > -1 && nomeAcao !== "Disponibilizar para retirada") ||
        ([Triagem].indexOf(idStatus) > -1 && nivel === Criacao) || ([Consultor, Interno, Supervisor, Administrador].indexOf(nivel) > -1 &&
          ([FechamentoDeArquivo].indexOf(idStatus) > -1 && data.statusId !== AprovacaoDeArte))) && !motivoDevolver) {
        toast.warn("Informe o motivo");
        return;
      }

      if ((!ocorrenciaFechamentoArquivo || ocorrenciaFechamentoArquivo.trim().length < 30) && [FechamentoDeArquivo].indexOf(data.statusId) > -1 && nomeAcao === "Concluir") {
        toast.warn("Informe o local onde foi salvo o arquivo para concluir");
        return;
      }

      if (([FechamentoDeArquivo].includes(data.statusId)) && idStatus === Finalizado && this.isProdutoDigital()) {
        if (!diaEntrega) {
          toast.warn("Informe o dia da entrega");
          return;
        }
        if (!responsavelRecebimento) {
          toast.warn("Informe o nome do responsável pelo recebimento");
          return;
        }
        if (!ocorrenciaFechamentoArquivo || ocorrenciaFechamentoArquivo.trim().length < 30) {
          toast.warn("Informe o local onde foi salvo o arquivo para concluir");
          return;
        }

        const arrayRequest = data.itensAgencia.resultado.map(p => p.id);

        const obj = {
          "status": idStatus,
          lstIdItemPedido: arrayRequest,
          mensagem: motivoDevolver,
          dataEntregaFornecedor: diaEntrega,
          responsavelRecebimento,
          ocorrenciaFechamentoArquivo
        }
        await updateDmService('/Pedido/AtualizaStatusItemPedidoAgencia', "", obj);
        this.setState({ motivoDevolver: "" })

      } else if ([DisponivelParaRetirada, Finalizado].indexOf(idStatus) > -1 || ([Fornecedor].indexOf(idStatus) > -1 && nomeAcao === "Retornar para Fornecedor")) {
        if (selectedRows && selectedRows.ids.length > 0) {
          if ([Finalizado].indexOf(idStatus) > -1 && !diaEntrega) {
            toast.warn("Inform o dia da entrega");
            return;
          }
          await this.setState({ idsItemPedido: selectedRows.ids });
          const obj = {
            "status": idStatus,
            mensagem: motivoDevolver,
            lstIdItemPedido: selectedRows.ids
          }

          if ([Finalizado].indexOf(idStatus) > -1) {
            const dataRequest = moment(diaEntrega).format("MM-DD-YYYY");
            obj.dataEntregaFornecedor = moment(dataRequest).toISOString();
          }
          try {
            // console.log("obj test", obj);
            await updateDmService('/Pedido/AtualizaStatusItemPedidoAgencia', "", obj);
            this.setState({ motivoDevolver: "" })
          } catch (error) {
            console.log("error test", error)
          }

        } else {
          toast.warn("Selecione os itens desejados.");
        }
      } else {
        const obj = { "status": idStatus, "lstIdPedido": [match.params.id], mensagem: motivoDevolver, ocorrenciaFechamentoArquivo }
        await updateDmService('/Pedido/AtualizaStatusPedidoAgencia', "", obj);
        await toast.success(mensagemSucesso);
      }

      this.load();
      this.toggleModal(modal)
    } catch (e) {
      this.errorHandler(e);
    }
  }

  onChangeStatusItem = (idStatusItem) => {
    this.setState({ idStatusItem, exibirdataStatusItem: idStatusItem === Finalizado, exibeDescricao: idStatusItem === Fornecedor });
  }

  onChangeEstado = (estadoId) => {
    this.setState({ estadoId }, () => {
      this.setState({ cidadeId: 0 })
      this.loadCidades();
    });
  }

  onChangeCidade = (cidadeId) => {
    this.setState({ cidadeId });
  }

  onChangeFornecedor = (idFornecedor) => {
    this.setState({ idFornecedor });
  }

  onChangeDate = (date, name) => {
    const newDate = date ? moment(date[0]).format('DD/MM/YYYY') : date;

    this.setState({
      [name]: newDate
    })
  }

  onChangeDateTest = (date, name) => {
    this.setState({ [name]: date });
  };

  saveStatusItem = async () => {
    const { idItemPedido, idStatusItem, dataStatusItem, motivoDevolverItem } = this.state;
    if (!idStatusItem) {
      toast.warn("Selecione o novo status do item")
    } else if (idStatusItem === Finalizado && !dataStatusItem) {
      toast.warn("Informe a data")
    } else if (idStatusItem === Fornecedor && !motivoDevolverItem) {
      toast.warn("Informe o motivo")
    } else {
      try {
        const arrayRequest = [idItemPedido];
        const obj = {
          "status": idStatusItem,
          mensagem: motivoDevolverItem,
          lstIdItemPedido: arrayRequest
        }
        if (dataStatusItem) {
          const dataRequest = moment(dataStatusItem).format("MM-DD-YYYY");
          obj.DataRecebimentoFornecedor = dataRequest;
        }

        await updateDmService('/Pedido/AtualizaStatusItemPedidoAgencia', "", obj);
        this.setState({ motivoDevolver: "", idStatusItem: 0, motivoDevolverItem: "", dataStatusItem: "", exibeDescricao: false, exibirdataStatusItem: false })
        toast.success("Status do item atualizado com sucesso");
        this.load();
        this.toggleModal("openTrocaDeStatus")
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  openModalNovaDataDesejada = () => {
    this.toggleModal('openModalNovaDataDesejada')
  }

  openDelegaDesigner = () => {
    this.toggleModal('openModalResponsavel')
  }

  openModalFornecedor = async (id, idTagPreco, grupos) => {
    await this.setState({ idItemPedido: id, idsItemPedido: [], idTagPreco, grupos });
    await this.loadFornecedor();
    this.toggleModal('openModalFornecedor')
  }

  openModalFornecedorSelecionado = async () => {
    const { selectedRows, data } = this.state;
    if (selectedRows && selectedRows.ids.length > 0) {
      const idTagPreco = data.itensAgencia.resultado.filter(p => selectedRows.ids.indexOf(p.id) > -1).map(p => p.idTagPreco)
      const grupos = data.itensAgencia.resultado.filter(p => selectedRows.ids.indexOf(p.id) > -1).map(p => p.idGrupo)
      await this.setState({ idsItemPedido: selectedRows.ids, idTagPreco, grupos });
      await this.loadFornecedor();
      this.toggleModal('openModalFornecedor')
    } else {
      toast.warn("Selecione algo");
    }
  }

  openModalTrocaStatus = async (id) => {
    await this.setState({ idItemPedido: id });
    this.setState({ openTrocaDeStatus: true })
  }

  openModalOrcar = (row) => {
    if (typeof row === "object") {
      const { data } = this.state;
      const value = data.itensAgencia.resultado.find(item => item.id === row.id);
      const { unidadeMedida } = value;
      const nomeUnidadeMedida = unitsOfmeasurement.find(v => parseInt(v.id, 10) === unidadeMedida).label;
      this.setState(prevState => ({
        idAction: row.id,
        openMdOrcar: !prevState.openMdOrcar,
        nomeUnidadeMedida
      }))
    } else {
      this.setState(prevState => ({
        openMdOrcar: !prevState.openMdOrcar,
        valorOrcamento: "",
      }))
    }
  }

  openModalDeletar = (id) => {
    this.setState(prevState => ({
      idAction: id,
      openMdDelete: !prevState.openMdDelete
    }))
  } 

  openModalLogistica = () => {
    this.toggleModal('openModalLogistica');
  }

  openModalConfirmacao = (value) => {
    this.setState({ newStatusModalConfirmacao: value })
    this.toggleModal('openModalConfirmacao');
  }

  insertBudgetValue = async () => {
    const { idAction, valorOrcamento } = this.state;
    const formData = {
      IdItemPedido: idAction,
      Valor: valorOrcamento
    }
    try {
      await pathDmService('/Pedido/AjustaValorOrcamento', formData);
      await this.load();
      await toast.success("Valor inserido com sucesso");
      await this.openModalOrcar(0);
    } catch (error) {
      toast.warn(error.message);
      console.log(error);
    }
  }

  deletarItemPedido = async () => {
    const { idAction, motivoExcluir } = this.state;
    if (!motivoExcluir) {
      toast.warn("Informe o motivo")
    } else {
      try {
        await deleteDmService('/Pedido/DeleteItemPedido', `${idAction}?motivo=${motivoExcluir}`);
        await this.load();
        await toast.success("Item removido conforme o solicitado");
        await this.openModalDeletar(0);
      } catch (error) {
        toast.warn(error.message);
        console.log(error);
      }
    }
  }

  editHistorico = (id) => {
    const { nivel } = this.state;
    if (nivel !== Administrador)
      return;
    const { data } = this.state;
    const item = data.custosAdicionais.find(p => p.id === id) || {};
    const fonecedorOrcamento = item.nome || "";
    const valorCustoOrcamento = item.valorFormatado || ""
    this.setState({ idItem: id, fonecedorOrcamento, valorCustoOrcamento });
    this.toggleModal('openCustoAdicional')
  }

  editRastreio = () => {
    const { data } = this.state;
    this.setState({ codigoRastreio: data.codigoRastreio });
    this.toggleModal('openTracking')
  }

  delete = async (id) => {
    try {
      await deleteDmService('/CustoAdicional/', id);
      toast.success('Item removido com sucesso');
      this.load();
      this.toggleModal('openCustoAdicional')
    } catch (e) {
      this.errorHandler(e);
    }
  }

  saveOcorrencia = async () => {
    const { fonecedorOrcamento, valorCustoOrcamento, idItem } = this.state;
    const { match } = this.props;

    if (!fonecedorOrcamento) {
      toast.warn("Informe o Fornecedor")
    } else if (!valorCustoOrcamento) {
      toast.warn("Informe o Valor")
    } else {
      try {
        const obj = {
          "IdPedido": match.params.id,
          "Nome": fonecedorOrcamento,
          "Valor": valorCustoOrcamento
        }
        if (idItem > 0) {
          await updateDmService('/CustoAdicional', idItem, obj);
        } else {
          await insertDmService('/CustoAdicional', obj);
        }

        toast.success('Dados atualizados com sucesso');
        this.load();
        this.toggleModal('openCustoAdicional')
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  saveTracking = async () => {
    const { codigoRastreio } = this.state;
    const { match } = this.props;

    if (!codigoRastreio) {
      toast.warn("Informe o código de rastreio")
    } else {
      try {
        
        await updateDmService('/Pedido/Tracking', match.params.id, {
          codigoRastreio
        });

        toast.success('Dados atualizados com sucesso');
        this.load();
        this.toggleModal('openTracking')
      } catch (e) {
        this.errorHandler(e);
      }
    }
  }

  saveConferido = async (e, id) => {
    e.stopPropagation();
    try {
      await pathDmService(`/Pedido/ConteudoVerificado/${id.replace(":conferido", "")}`, "null");
      toast.success('Dados atualizados com sucesso');
      this.load();
    } catch (ex) {
      this.errorHandler(ex);
    }
  }

  onDeploymentSelection = (selectedRows, currentRow) => {
    let newList = selectedRows;
    if (!currentRow.isSelected) {
      newList.push(currentRow);
    } else {
      newList = selectedRows.filter(p => p.id !== currentRow.id);
    }
    const result = { ids: [], rows: [] };
    newList.forEach(p => {
      result.ids.push(p.id);
      result.rows.push(p);
    });
    this.setState({ selectedRows: result })
  }

  setSelectedAll = (rows, selectRow, selectedRows) => {
    this.setState(prevState => ({
      selectedAll: !prevState.selectedAll
    }), () => {
      this.onSelectedAll(rows, selectRow, selectedRows)
    })
  }

  onSelectedAll = (rows) => {
    const { selectedAll } = this.state;
    const result = { ids: [], rows: [] };
    for (const item of rows) {
      result.ids.push(item.id);
      result.rows.push(item)
    }

    if (selectedAll) {
      this.setState({ selectedRows: result })
    } else {

      for (const item of rows) {
        result.ids.pop(item.id)
        result.rows.pop(item)
      }
      this.setState({ selectedRows: result })
    }
  }

  errorHandler = err => {
    const existError = Object.prototype.hasOwnProperty.call(err, "error");
    const existResponse = existError ? Object.prototype.hasOwnProperty.call(err.error, "response") : false;
    const existData = existResponse ? Object.prototype.hasOwnProperty.call(err.error.response, "data") : false;
    if (err.error && existError && existResponse && existData && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } if (err.message)
      toast.error(err.message);
    else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  toggleModal = (modal) => {
    this.setState(prevState => ({
      [modal]: !prevState[modal]
    }));
  }

  onChange = event => {
    this.setState({ [event.target.id]: event.target.value /* , isEdited: true */ });
  };

  onChangeDesigner = (value) => {
    this.setState({ idDesigner: value });
  };

  onChangeRedatora = (value) => {
    this.setState({ isRedatora: value });
  };

  onChangePrioridade = (value) => {
    this.setState({ isPrioridade: value });
  };

  onChangeText = (event) => {
    const { target } = event;
    const { value, id } = target;

    this.setState({
      [id]: value
    });
  }

  onChangeCheckEquipe = (idEquipe) => {
    this.setState({ idEquipe });
  }

  openDesignarEquipe = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        openMdEquipe: !prevState.openMdEquipe
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  openDesignarSolicitante = () => {
    const { idsRequests } = this.state;
    if (idsRequests.length) {
      this.setState(prevState => ({
        openMdSolicitante: !prevState.openMdSolicitante
      }))
    } else {
      toast.warn("Você precisa selecionar o pedido.");
    }
  }

  loadSolicitante = async () => {
    const { match } = this.props;
    const { searchSolicitante } = this.state;
    try {
      const solicitantes = await getDmService(`/Equipe/Usuarios?q=${searchSolicitante}`);
      this.setState({
        solicitantes,
      });
    } catch (e) {
      if (match.params.id > 0)
        toast.error("Ocorreu um erro ao carregar os dados");
    }
  }

  getEquipes = async () => {
    try {
      const equipes = await getDmService('/Equipe/GetAtivas');
      await this.setState({ equipes: equipes || [] });
    } catch (error) {
      console.log(error);
    }
  }

  onChangeSolicitante = idSolicitante => {
    this.setState({ idSolicitante })
  }

  delegaSolicitante = async () => {
    const { idsRequests, idSolicitante } = this.state
    try {
      await updateDmService('/Pedido/DelegaSolicitante', idSolicitante, { pedidos: idsRequests });
      this.openDesignarSolicitante();
      toast.success("Dados atualizados com sucesso");
      this.load();
    } catch (e) {
      toast.error("Ocorreu uma falha ao salvar os dados");
    }
  }

  delegaEquipe = async () => {
    const { idsRequests, idEquipe } = this.state
    try {
      await updateDmService('/Pedido/DelegaEquipe', idEquipe, { pedidos: idsRequests });
      this.openDesignarEquipe();
      toast.success("Dados atualizados com sucesso");
      this.load();
    } catch (e) {
      toast.error("Ocorreu uma falha ao salvar os dados");
    }
  }

  onSearchSolicitanteChange = event => {
    clearTimeout(this.searchTimeout);
    const { value } = event.target;
    this.setState({ searchSolicitante: value, page: 1 });
    this.searchTimeout = setTimeout(() => {
      this.setState(
        {
          searchSolicitante: value || ""
        },
        () => {
          this.loadSolicitante();
        }
      );
    }, 1800);
  };

  isProdutoDigital = () => {
    const { data } = this.state;
    return (data && data.itensAgencia && data.itensAgencia.resultado ? data.itensAgencia.resultado : [])
      .reduce((valDefault, obj) => {
        if (!valDefault)
          return false
        if (!obj.concluirNoFechamentoArquivo)
          return false
        return true;
      }, true)
  }

  isLogisticsButtonVisible = (data, statusId, isAdminEspecial) => {
    const isVisible = 
      ([Administrador, Interno].indexOf(statusId) && 
      (statusId > StatusCriacao || statusId < StatusCriacao || statusId === Devolvido) 
      && !isAdminEspecial && data.logistica) || (statusId === AprovacaoDeArte && data.logistica);
    return isVisible;
  }

  isTrackingButtonVisible = (statusId) => {
    const isVisible = statusId === Fornecedor;
    return isVisible;
  }

  renderButtons = (statusId, nivel, existOrcamentoObrigatorio, data) => {
    const userValues = JSON.parse(localStorage.getItem("user"));
    const nomeCompleto = `${userValues.nome  } ${  userValues.sobreNome}`;
    const { agencia, trade, comunicacao, cadastros } = (userValues || {});
    const isAdminTrade = !agencia && nivel === Administrador && trade;
    const isAdminComunication = comunicacao === true && nivel === Administrador && !agencia;
    const isAdminCadastro = cadastros && nivel === Administrador && !agencia;
    const isAdminEspecial = isAdminTrade || isAdminComunication || isAdminCadastro;

    return (
      <div className="bx--col-md-12 bx--col-xs-12">
        <div className=" f-right">
          {/* {nivel === Administrador && [18].indexOf(statusId) > -1  && !isAdminEspecial && (
            <button
              className="bx--btn bx--btn--danger h-sm-margin"
              type="button"
              disabled={data && (data.itensAgencia.resultado.filter(p=> p.excluido === false && p.statusAprovacao === 2).length === 0 || data.itensAgencia.resultado.filter(p=> p.excluido === false && p.statusAprovacao === 0).length > 0)}
              onClick={() => this.setState({ openModalReprovar: true })}
            >
              Reprovar pedido
            </button>
          )} */}
          {nivel === Administrador && [Criacao].indexOf(statusId) > -1 && (
            <React.Fragment>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openModalConfirmacao(StatusCriacao)}
              >
                Criação
              </button>

              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openModalConfirmacao(AprovacaoDeArte)}
              >
                Aprov Arte
              </button>
            </React.Fragment>
          )}

          {nivel === Administrador && [Redatora].indexOf(statusId) > -1 && !isAdminEspecial && (
            <React.Fragment>
              <button
                className="bx--btn btn-primary-outlined h-sm-margin"
                type="button"
                onClick={() => this.reprovarRedacao()}
              >
                Reprovar pedido
              </button>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.enviarParaCriacao()}
              >
                Enviar para Criação
              </button>
            </React.Fragment>
          )}
          {this.isLogisticsButtonVisible(data, statusId, isAdminEspecial) && (
          <React.Fragment>
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.openModalLogistica()}
            >
              Logistica
            </button>
          </React.Fragment>
          )}
          {nivel === Administrador && [Triagem].indexOf(statusId) > -1 && !isAdminEspecial && (
          <React.Fragment>
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.openDelegaDesigner()}
              disabled={existOrcamentoObrigatorio}
            >
              Criação
            </button>
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              // onClick={() => this.openModalConfirmacao(StatusRedacao)}
              onClick={() => this.openDelegaDesigner()}
            >
            Redação
            </button>
          </React.Fragment>
          )}
          {nivel === Administrador && [Triagem].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.supervisaoTrade()}
            >
              Supervisão trade
            </button>
          )}
          {nivel === Administrador && [AguardandoProducao].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-primary-outlined h-sm-margin"
              type="button"
              onClick={() => this.reprovarProducao()}
            >
              Reprovar pedido
            </button>
          )}
          {/* {([30, 50, 60, 10].indexOf(nivel) > -1) && [19].indexOf(statusId) > -1 && (
            <button
              className="bx--btn bx--btn--danger h-sm-margin"
              type="button"
              disabled={data && (data.itensAgencia.resultado.filter(p=> p.excluido === false && p.statusAprovacao2 === 2).length === 0 || data.itensAgencia.resultado.filter(p=> p.excluido === false && p.statusAprovacao2 === 0).length > 0)}
              onClick={() => this.reprovarArte()}
            >
              Reprovar pedido
            </button>
          )} */}
          {(nivel === GerenteComercial || this.state.listaSolicitanteComercial.includes(nomeCompleto) > -1) && [AprovacaoComercial].indexOf(statusId) > -1 && (
            <button
              className="bx--btn btn-primary-outlined h-sm-margin"
              type="button"
              onClick={() => this.reprovarComercialmente()}
            >
              Reprovar pedido
            </button>
          )}
          {/* {((nivel === Administrador && [StatusCriacao, Triagem, SupervisaoTrade, Redatora, AprovacaoDeRedacao].indexOf(statusId) > -1 && !isAdminEspecial) || (nivel === Criacao && [StatusCriacao].indexOf(statusId) > -1)) && ( */}
          {((nivel === Administrador && !isAdminEspecial) || (nivel === Criacao && [StatusCriacao].indexOf(statusId) > -1)) && (
            <button
              className="bx--btn btn-secondary-outlined h-sm-margin"
              type="button"
              onClick={() => { this.devolverItem() }}
            >
              Devolver ao Solicitante
            </button>
          )}
          {/* {((nivel === Administrador && [FechamentoDeArquivo, AguardandoProducao].includes(statusId) && !isAdminEspecial)) && ( */}
          {((nivel === Administrador && !isAdminEspecial)) && (
            <button
              className="bx--btn btn-secondary-outlined h-sm-margin"
              type="button"
              onClick={() => { this.devolverStatusAnterior(statusId) }}
            >
              Retornar Status Anterior
            </button>
          )}
          {((nivel === Administrador && [AmostraDeCartao].includes(statusId) && !isAdminEspecial)) && (
            <button
              className="bx--btn btn-secondary-outlined h-sm-margin"
              type="button"
              onClick={() => this.devolverCriacao()}
            >
              Devolver a Criação
            </button>
          )}
         
          {[Administrador, Criacao].indexOf(nivel) > -1 && [RevisaoInterna].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.revisaoInterna()}
            >
              {/* Revisão Int. */}
              {nivel === Administrador ? "Revisão" : "Enviar"}
            </button>
          )}

   
          {[Administrador, Criacao].indexOf(nivel) > -1 && [RevisaoInterna].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.supervisao()}
            >
              {/* Revisão Int. */}
              {nivel === Administrador ? "Supervisão" : "Enviar"}
            </button>
          )}
          {[Administrador, Criacao].indexOf(nivel) > -1 && [StatusCriacao].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.revisaoInterna()}
            >

              {/* Revisão Cria. */}
              {nivel === Administrador ? "Revisão" : "Enviar"}
            </button>
          )}
          {/* {nivel === Administrador && [StatusCriacao].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.openDelegaDesigner()}
            >
              Alterar Designer
            </button>
          )}
          {nivel === Administrador && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.openModalNovaDataDesejada()}
            >
              Alterar Data Desejada
            </button>
          )} */} 
          {nivel === Administrador && [SupervisaoTrade].indexOf(statusId) > -1 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.enviarTriagem()}
            >
              Enviar Triagem
            </button>
          )}
          {(nivel === GerenteComercial || 
          // eslint-disable-next-line react/destructuring-assignment
          this.state.listaSolicitanteComercial.includes(nomeCompleto) > -1) 
          && [AprovacaoComercial].indexOf(statusId) > -1 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.aprovacaoDoComercial()}
            >
              Aprovar pedido
            </button>
          )}
          {/* {[30, 50, 60, 10].indexOf(nivel) > -1 && [19].indexOf(statusId) > -1 && (
            <button
              className="bx--btn bx--btn--primary h-sm-margin"
              type="button"
              disabled={data && data.itensAgencia.resultado.filter(p=> p.excluido === false && p.statusAprovacao2 !== 1).length > 0}
              onClick={() => this.aprovacaoDeArte()}
            >
              Aprovar pedido
            </button>
          )} */}
          {nivel === Administrador && [Orcamento].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.enviarParaAguardProd()}
            >
              Enviar Aguardando Producão
            </button>
          )}
          {nivel === Administrador && [AguardandoProducao, AmostraDeCartao, Fornecedor].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.atualizarParaEntregueModal()}
            // onClick={() => this.finalizar()}
            >
              Finalizar Pedido
            </button>
          )}
          {[Consultor, Interno, Supervisor, Administrador].indexOf(nivel) > -1 && [Devolvido].indexOf(statusId) > -1 && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.concluirConsultor()}
            >
              Enviar Pedido
            </button>
          )}
          {nivel === Administrador && [AguardandoProducao].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.openModalFornecedorSelecionado()}
            >
              Produção
            </button>
          )}
          {[Administrador, Criacao].indexOf(nivel) > -1 && [FechamentoDeArquivo].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => {
                if (this.isProdutoDigital())
                  this.finalizar()
                else
                  this.concluirPedido()
              }}
            >
              Concluir
            </button>
          )}
          {nivel === Administrador && [Fornecedor].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.disponivelParaRetirada()}
            >
              Disponível para retirada
            </button>
          )}
          {/* {nivel === Administrador && [Fornecedor].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.emTransporte()}
            >
              Em transporte
            </button>
          )} */}
          {nivel === Administrador && [DisponivelParaRetirada, EmTransporte].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.atualizarParaEntregueModal()}
            >
              Pedido entregue
            </button>
          )}
          {nivel === Administrador && [DisponivelParaRetirada, EmTransporte].indexOf(statusId) > -1 && !isAdminEspecial && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.retornaFornecedor()}
            >
              Retorna para fornecedor
            </button>
          )}
          {(([Supervisor, Consultor, Interno].indexOf(nivel) > -1 && [Triagem].indexOf(statusId) > -1) ||
            (nivel === Administrador && [Finalizado].indexOf(statusId) === -1) ||
            ([Supervisor, Consultor].indexOf(nivel) > -1 && [Devolvido].indexOf(statusId) > -1)) && !isAdminEspecial && (
              <button
                className="bx--btn btn-primary-outlined h-sm-margin"
                type="button"
                onClick={() => this.cancelarItem()}
              >
                Cancelar
              </button>
            )}
          {nivel === Administrador && agencia && (
            <React.Fragment>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openDesignarEquipe()}
              >
                Alterar Equipe
              </button>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openDesignarSolicitante()}
              >
                Alterar Solicitante
              </button>
            </React.Fragment>
          )}
          {nivel !== Administrador && data && data.solicitante && data.solicitante.id === userValues.id && (
            <button
              className="bx--btn btn-secondary-color h-sm-margin"
              type="button"
              onClick={() => this.openDesignarEquipe()}
            >
              Alterar Equipe
            </button>
          )}
        </div>
      </div>
    );
  }

  renderRow = (cell, data, rowData, row, id, permissionForAgency) => {
    const { statusId, nivel } = this.state;
    return (
      <div>
        {cell.info.header.toLowerCase() === 'produtoresumo' ? (
          <div>
            <img
              alt=""
              style={{ marginRight: "10px" }}
              className="img-responsive"
              src={IMAGE_PATH + (data.itensAgencia.resultado.find(p => p.id === row.id) || {}).fotoProduto}
            />
            {cell.value}
          </div>
        ) :
          cell.info.header.toLowerCase() === 'id' ? (
            <div>
              {/* ajustes para visivel quando excluir, incluir mensagens */}
              {/* {!rowData.excluido && ( */}
              {/* <Link onClick={(e) => { e.stopPropagation() }} to={rowData.excluido ? '#' : `/admin/agencia/arte-pedido/${id}/${cell.value}`}> */}
              {(
                <Link onClick={(e) => { e.stopPropagation() }} to={`/admin/agencia/arte-pedido/${id}/${cell.value}`}>
                  <i className="material-icons animated tada delay-5s v-middle pointer">
                    {(data.itensAgencia.resultado.find(p => p.id === row.id) || { qtdUploads: 0 }).qtdUploads > 0 ? "attach_file" : "backup"}
                  </i>
                </Link>
              )}
            </div>
          ) :
            (cell.info.header.toLowerCase() === 'statusaprovacao2' || cell.info.header.toLowerCase() === 'statusaprovacao' || cell.info.header.toLowerCase() === 'statusaprovacaoredacao' || cell.info.header.toLowerCase() === 'statusaprovacaosupervisao') ? (
              <div>
                <i className="material-icons animated tada delay-5s v-middle pointer" style={{ color: (cell.value === 0 ? "#DDD" : cell.value === 1 ? "#65F282" : "#FF6666") }}>fiber_manual_record</i>
              </div>
            ) :
              cell.info.header.toLowerCase() === 'fornecedor' && statusId !== Finalizado && permissionForAgency ? (
                <div style={{ padding: "5px" }}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!rowData.excluido) {
                        this.openModalFornecedor(row.id,
                          [(data.itensAgencia.resultado.find(p => p.id === row.id) || {}).idTagPreco],
                          [(data.itensAgencia.resultado.find(p => p.id === row.id) || {}).idGrupo]
                        )
                      }
                    }}
                  >
                    {cell.value || "Nenhum"}
                  </Link>
                  {(data.itensAgencia.resultado.find(p => p.id === row.id) || {}).nomeTransportadora && (
                    <p>
                      {(data.itensAgencia.resultado.find(p => p.id === row.id) || {}).nomeTransportadora}
                    </p>
                  )}
                </div>
              ) :
                cell.info.header.toLowerCase() === 'conferido' ? (
                  <div>
                    <Link to="#" onClick={async (e) => { if (!rowData.excluido) { await this.saveConferido(e, cell.id) } }}>
                      <i className="material-icons animated tada delay-5s big-icon-table" style={{ color: !cell.value ? "#bec8d1" : "#52b04e" }}>
                        {!cell.value ? "check_circle_outline" : "check_circle"}
                      </i>
                    </Link>
                  </div>
                ) :
                  cell.info.header.toLowerCase() === 'aviso' ? (
                    <div>
                      {cell.value && (<i className="material-icons animated tada delay-5s big-icon-table" style={{ color: "red" }}>report_problem</i>)}
                    </div>
                  ) :
                    cell.info.header.toLowerCase() === 'status' ? (
                      <div>
                        {rowData.excluido ? "Excluído" : cell.value}
                        {/* <Link to="#" onClick={() =>  this.openModalTrocaStatus(row.id)}>
                        {cell.value}
                        <i className="material-icons animated tada delay-5s v-middle pointer">arrow_drop_down_circle</i>
                      </Link> */}
                      </div>
                    ) : cell.info.header.toLowerCase() === "valorunitarioformatado" && data.itensAgencia.resultado.find(p => p.id === row.id).orcamentoObrigatorio &&
                      cell.value === "Orçamento Obrigatório" && [Administrador].indexOf(nivel) > -1 && permissionForAgency ? (
                        <div>
                          <Link
                            to="#"
                            title="Orçamento obrigatório"
                            onClick={() => { if (!rowData.excluido) { this.openModalOrcar(row) } }}
                          >
                            <i style={{ fontSize: 22, color: "red" }} className="material-icons animated delay-5s">edit</i>
                            Orçar
                          </Link>
                        </div>
                    ) : (
                      data.itensAgencia.resultado.find(p => p.id === row.id).orcamentoObrigatorio &&
                      cell.info.header.toLowerCase() === "valorunitarioformatado") && [Administrador].indexOf(nivel) > -1 && permissionForAgency ? (
                        <Link
                          to="#"
                          title="Orçamento obrigatório"
                          onClick={() => { if (!rowData.excluido) { this.openModalOrcar(row) } }}
                        >
                          <i style={{ fontSize: 22, color: "red" }} className="material-icons animated delay-5s">edit</i>
                          {' '}
                          {`${cell.value}`}
                        </Link>
                    )
                      : (cell.info.header.toLowerCase() === "valorunitarioformatado") && [Administrador].indexOf(nivel) > -1 && permissionForAgency && cell.value.startsWith("R$") ?
                        (
                          <Link
                            to="#"
                            title="Editar preço"
                            onClick={() => { if (!rowData.excluido) { this.openModalOrcar(row) } }}
                          >
                            {!rowData.excluido && (<i style={{ fontSize: 22 }} className="material-icons animated delay-5s">edit</i>)}
                            {' '}
                            {`${cell.value}`}
                          </Link>
                        )
                        :
                        cell.value
        }
      </div>
    )
  }

  renderDescription = (data, unidadesIds) => {
    const { history } = this.props;

    return (
      data && (
        <React.Fragment>
          <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
            <svg width="16" height="14" viewBox="0 0 16 14">
              <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
            </svg>
          </div>
          <div className="render-buttons-left-agency">
            <p className="title-description-request" title={`${data.numero} ${data.nomePedido ? ' - ' : ''} ${data.nomePedido || ""}`}>
              {`${data.numero} ${data.nomePedido ? ' - ' : ''} ${data.nomePedido || ""}`}
              {!!data.nota && (
                <StarRatings
                  rating={data.nota}
                  starRatedColor="gray"
                  numberOfStars={5}
                  name='rating'
                  starDimension="24px"
                  starSpacing="5px"
                />
              )}
            </p>
            <p className="title-description-request" title={`${data.unidades.length ? data.unidades[0].unidade.nome : ""} - ${data.unidades.length ? data.unidades[0].loja.nome : ""}`}>

              {unidadesIds.length === 1 ? data.unidades[0].unidade.nome : `${unidadesIds.length} Unidades`}

              {data.unidades.length === 1 && (
                <React.Fragment>
                  <br />
                  <span className="small-title">{data.unidades[0].loja.nome}</span>
                </React.Fragment>
              )}
              {data.unidades.length > 1 && (
                <React.Fragment>
                  <p>
                    <Link to="#" onClick={() => { this.setState({ "modalLojas": true }) }} className="small-link">
                      {`Ver as ${data.unidades.length} lojas do pedido`}
                    </Link>
                  </p>
                </React.Fragment>
              )}
            </p>
          </div>
        </React.Fragment>
      )
    );
  }

  renderDescription2 = (data) => (
    data && (
      <React.Fragment>
        <div className="render-buttons-right-agency">
          <p>
            Solicitado em&nbsp;
            <strong>{moment(data.dataSolicitacao).format("DD/MM/YYYY")}</strong>
            &nbsp;por&nbsp;
            <strong>{`${data.solicitante.nome}`}</strong>
          </p>
          <p>{`Equipe: ${data.equipe || 'N/I'}`}</p>
          <p className="italic">{`${data.custeio} - ${data.segmento}`}</p>
        </div>
      </React.Fragment>
    )
  )

  openModalRating = () => {
    this.setState({ openRatingModal: true })
  }

  closeModalRating = () => {
    this.setState({ openRatingModal: false })
  }

  changeRating = (val, name) => {
    this.setState({
      [name]: val
    });
  }

  saveRating = async () => {
    const { match } = this.props;
    const {
      notaCriacao, notaCriacaoComentario,
      notaMaterial, notaMaterialComentario,
      notaAtendimento, notaAtendimentoComentario
    } = this.state;
    if ((notaCriacao < 4 && !notaCriacaoComentario) ||
      (notaMaterial < 4 && !notaMaterialComentario) ||
      (notaAtendimento < 4 && !notaAtendimentoComentario)) {
      toast.warn("O comentário é obrigatório para notas menores que 4 estrelas.")
    } else {
      try {
        await updateDmService('/Pedido/Avaliacao', match.params.id, {
          notaCriacao, notaCriacaoComentario,
          notaMaterial, notaMaterialComentario,
          notaAtendimento, notaAtendimentoComentario
        });
        this.closeModalRating();
        toast.success("Avaliação registrada com sucesso");
        this.load();
      } catch (e) {
        toast.error("Ocorreu uma falha ao salvar a avaliação");
      }
    }
  }

  render() {
    const {
      data,
      notaCriacao,
      notaCriacaoComentario,
      notaMaterial,
      notaMaterialComentario,
      notaAtendimento,
      notaAtendimentoComentario,
      openRatingModal,
      openCustoAdicional,
      openTrocaDeStatus,
      openModalFornecedor,
      openModalResponsavel,
      openModalNovaDataDesejada,
      openModalCancelar,
      fonecedorOrcamento,
      valorCustoOrcamento,
      idItem,
      dataEstimada,
      idDesigner,
      listDesigners,
      listRedatora,
      isRedatora,
      listPrioridades,
      isPrioridade,
      nomeAcao,
      dataStatusItem,
      idStatusItem,
      idStatus,
      dataEstimativaEntrega,
      idFornecedor,
      motivoDevolver,
      ocorrenciaFechamentoArquivo,
      fornecedores,
      cidadeId,
      estadoId,
      estados,
      cidades,
      search,
      novaDataEstimada,
      novaDataDesejada,
      openModalReprovar,
      nivel,
      diaEntrega,
      modalLojas,
      unidadesIds,
      exibirdataStatusItem,
      exibeDescricao,
      motivoDevolverItem,
      openModalEmTransporte,
      nomeTransportadora,
      openModalFinalizarPedido,
      responsavelEntrega,
      responsavelRecebimento,
      openMdOrcar,
      valorOrcamento,
      existOrcamentoObrigatorio,
      openMdDelete,
      nomeUnidadeMedida,
      motivoExcluir,
      openMdSolicitante,
      openMdEquipe,
      solicitantes,
      idSolicitante,
      idEquipe,
      equipes,
      searchSolicitante,
      width,
      openModalLogistica,
      logistica,
      openModalConfirmacao,
      newStatusModalConfirmacao,
      codigoRastreio,
      openTracking
    } = this.state;
    const { dataPrevisaoOriginal, dataDesejada, dataEstimadaProduto, statusId, id } = data || {};
    const arrStatusSemCheckbox = [Devolvido, Cancelado, StatusCriacao, Triagem, AprovacaoComercial, RevisaoInterna, AprovacaoDeArte, FechamentoDeArquivo];
    const userValues = JSON.parse(localStorage.getItem("user"));
    const permissionForAgency = (userValues || {}).agencia;
    const isAdmin = localStorage.getItem("showAdminMenu");
    // console.log("status id ", idStatus);
    const statusShowNameDesigner = [StatusCriacao, RevisaoInterna, AprovacaoDeArte, FechamentoDeArquivo, Supervisao];
    return (
      <div className="page-agency-order">
        <Breadcrumb
          title=""
          renderLeft={this.renderDescription(data, unidadesIds)}
          renderRight={this.renderDescription2(data, unidadesIds)}
        />
        <div className="content-wrapper" style={{ marginBottom: 20 }}>
          <div className="bx--row">
            {this.renderButtons(statusId, nivel, existOrcamentoObrigatorio, data)}
          </div>
        </div>
        {data && (
          <div className="content-wrapper">
            {existOrcamentoObrigatorio && data.status === "Triagem" && isAdmin === "true" && (
              <div className="bx--row">
                <div className="bx--col-md-12 bx--col-xs-12 bx--col-lg-12">
                  <Notification
                    kind="warning"
                    title="Atenção"
                    subtitle="para passar o pedido para criação você precisa preencher os valores de orçamentos obrigatórios."
                  />
                </div>
              </div>
            )}
            {(data.nota === 0 || data.nota === null) && (data.status === "Finalizado" || data.status === "Finalizado (Pend.Avaliação)") &&
              ([Administrador, Interno].includes(nivel) || (data.solicitante && data.solicitante.id === (JSON.parse(localStorage.getItem("user")) || {}).id))
              && (
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12 bx--col-lg-12">
                    <Notification
                      kind="error"
                      className="notification-rating"
                      title=""
                      hideCloseButton
                      subtitle={(
                        <div style={{ width: "100%" }}>
                          <p style={{ display: "inline-block", marginTop: 10 }}>Nos ajude a melhorar o nosso serviço, contamos com sua colaboração na avaliação deste pedido.</p>
                          <button
                            type="button"
                            style={{ float: "right", display: "inline-block", background: "#f42525", borderColor: "#f42525" }}
                            className="bx--btn btn-secondary-outlined h-sm-margin"
                            onClick={this.openModalRating}
                          >
                            Avaliar pedido
                          </button>
                        </div>
                      )}
                    />
                  </div>
                </div>
              )}

            <div className="bx--row detail-request-headers">
              <div className="bx--col-md-6 bx--col-xs-12">
                <div className="bx--row">
                  <div className="bx--col-md-3 bx--col-xs-12">
                    <p>
                      Status:
                      <strong>
                        {data.status}
                      </strong>
                    </p>
                  </div>
                  <div className="bx--col-md-3 bx--col-xs-12">
                    {(data.designer && statusShowNameDesigner.includes(data.statusId)) && nivel === Administrador && (
                      <p>
                        Designer:
                        <strong>
                          {data.designer}
                        </strong>
                      </p>
                    )}
                  </div>
                </div>
                {data.motivoPrioridade && (
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <p>
                        Motivo Prioridade: {data.motivoPrioridade}
                      </p>
                    </div>
                  </div>
              )}
              </div>
              <div className="bx--col-md-6 bx--col-xs-12">
                <div className="bx--row">
                  <div className="bx--col-md-6 bx--col-xs-12" style={{ padding: "0" }}>
                    <div className="bx--form-item--inline v-sm-margin calendar-box">
                      <FormItem>
                        <label className="bx--label">Previsão Triagem:</label>
                        {dataPrevisaoOriginal ? moment(dataPrevisaoOriginal).format('DD/MM/YYYY') : null}
                      </FormItem>
                    </div>
                  </div>
                  <div className="bx--col-md-6 bx--col-xs-12" style={{ padding: "0" }}>
                    <div className="bx--form-item--inline v-sm-margin calendar-box">
                      <FormItem>
                        <label className="bx--label">Previsão de Entrega:</label>
                        {dataDesejada ? moment(dataDesejada).format('DD/MM/YYYY') : null}
                      </FormItem>
                    </div>
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12" style={{ padding: "0" }}>
                    <div className="bx--form-item--inline v-sm-margin calendar-box">
                      <FormItem>
                        <label className="bx--label">Data Prevista Pedido:</label>
                        {dataEstimadaProduto ? moment(dataEstimadaProduto).format('DD/MM/YYYY') : null}
                      </FormItem>
                    </div>
                  </div>
                </div>
              </div>           
            </div>
            <DataTable
              rows={data.itensAgencia && data.itensAgencia.resultado ? data.itensAgencia.resultado : []}
              sortRow={this.customSortRow}
              headers={data.itensAgencia && data.itensAgencia.header ? data.itensAgencia.header : []}
              render={({
                rows,
                headers,
                getHeaderProps,
                getSelectionProps,
                selectedRows,
                selectRow,
              }) => {
                this.selectRow = selectRow;
                this.selectedRows = selectedRows;
                return (
                  <TableContainer>
                    <Table className="responsive-carbon-table">
                      <TableHead>
                        <TableRow>
                          {(arrStatusSemCheckbox.indexOf(statusId) === -1) && (
                            <TableSelectRow
                              {...getSelectionProps({
                                onClick: () => {
                                  this.setSelectedAll(rows, selectRow, selectedRows);
                                }
                              })}
                            />
                          )}
                          {width < 1024 && (<TableHeader />)}
                          {width >= 1024 && headers.map(header => (
                            <TableHeader
                              {...getHeaderProps({
                                header,
                                onClick: this.canRunSort
                              })}
                              style={{ width: "auto", float: header.align || 'left' }}
                            >
                              {header.header}
                            </TableHeader>
                          ))}
                          {((data.statusId === Triagem && [Administrador].includes(nivel)) || data.statusId === Devolvido || nivel === Administrador) && (
                            <TableHeader className="td-actions">
                              {width >= 1024 ? "Ações" : ""}
                            </TableHeader>
                          )}
                        </TableRow>
                      </TableHead>
                      {!data.itensAgencia.resultado.length ? (
                        <TableBody>
                          <tr>
                            <td colSpan={headers.length + 1}>
                              <div className="font-size-13">
                                Nenhum registro encontrado.
                              </div>
                            </td>
                          </tr>
                        </TableBody>
                      ) : (
                        <TableBody>
                          {rows.map(row => {
                            const rowData = data.itensAgencia.resultado.find(p => p.id === row.id);

                            return (
                              <TableRow key={`r${row.id}`}>
                                {(arrStatusSemCheckbox.indexOf(statusId) === -1) && (
                                  <TableSelectRow
                                    {...getSelectionProps({
                                      row,
                                      onClick: () => {
                                        this.onDeploymentSelection(
                                          selectedRows,
                                          row,
                                          selectRow
                                        );
                                      }
                                    })}
                                  />
                                )}
                                {width >= 1024 && row.cells.map(cell => {
                                  const headerObj = headers.find(obj => obj.key === cell.info.header);

                                  return (
                                    <TableCell
                                      key={`c${cell.id}`}
                                      className="pointer"
                                      style={{
                                        textAlign: headerObj.align || 'left',
                                        backgroundColor: rowData.excluido ? '#e6e6e6' : null,
                                        opacity: rowData.excluido ? '0.6' : '1'
                                      }}
                                      onClick={() => {
                                        // if (rowData.excluido) {
                                        //   return null;
                                        // }
                                        if (cell.info.header.toLowerCase() === "valorunitarioformatado") {
                                          return null;
                                        }
                                        return this.goEdit(row.id);
                                      }}
                                    >
                                      {this.renderRow(cell, data, rowData, row, id, permissionForAgency)}
                                    </TableCell>
                                  );
                                })}
                                {width < 1024 && (
                                  <TableCell
                                    key={row.id}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => 
                                       this.goEdit(row.id)
                                    }
                                  >
                                    <Card className="table-card">
                                      {row.cells.map((cell, index) => (
                                        <ul className="table-card-intems">
                                          <li>
                                            {headers.find(obj => obj.key === cell.info.header).header}
                                          </li>
                                          <li>:</li>
                                          <li>
                                            {this.renderRow(cell, data, rowData, row, id, permissionForAgency)}
                                          </li>
                                        </ul>
                                      ))}
                                    </Card>
                                  </TableCell>
                                )}
                                {((data.statusId === Triagem && [Administrador].includes(nivel)) || data.statusId === Devolvido || nivel === Administrador) && (
                                  <TableCell
                                    style={{
                                      backgroundColor: rowData.excluido ? '#e6e6e6' : null,
                                      opacity: rowData.excluido ? '0.6' : '1'
                                    }}
                                    className="td-actions"
                                  >
                                    {!rowData.excluido && (
                                      <button
                                        type="button"
                                        className="button button--clear danger  pointer f-right"
                                        onClick={() => this.openModalDeletar(row.id)}
                                      >
                                        <i className="material-icons">
                                          delete_outline
                                        </i>
                                      </button>
                                    )}
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                );
              }}
            />
            <div className="table-fluxo">
              <div>
                Subtotal:&nbsp;
                <strong>{data.subTotal}</strong>
              </div>
              <div style={{ padding: 10, textAlign: "right", fontSize: 12 }}>
                {this.isTrackingButtonVisible(statusId) && (
                  <span>
                    <ButtonLink onClick={() => this.editRastreio()}>
                      <i className="material-icons animated tada delay-5s">local_shipping</i>
                      <span>Rastreio</span>
                    </ButtonLink>
                  </span>
                )}
                {(nivel === 10 && permissionForAgency) && (
                  <span>
                    <ButtonLink onClick={() => this.editHistorico(0)}>
                      <i className="material-icons animated tada delay-5s">add_circle</i>
                      <span>Orçamento</span>
                    </ButtonLink>
                  </span>
                )}              
              </div>
              {data.custosAdicionais && data.custosAdicionais.map(item => (
                <div onClick={() => { this.editHistorico(item.id) }}>
                  {item.nome}
                  :&nbsp;
                  <strong>
                    (
                    {item.valorFormatado}
                    )
                  </strong>
                </div>
              ))}
              <div className="total">
                Total:&nbsp;
                <strong>{data.valorTotal}</strong>
              </div>
            </div>
            <div>
              <div style={{ padding: 10, textAlign: "left", fontSize: 12 }}>
                <span style={{ marginRight: 20 }}>
                  <i style={{ fontSize: 16, color: "red" }} className="material-icons animated delay-5s">edit</i>
                  Orçamento obrigatório
                </span>
                <span>
                  <i style={{ fontSize: 16, color: "blue" }} className="material-icons animated delay-5s">edit</i>
                  Editar preço
                </span>
              </div>
            </div>
            <OrderHistory nivel={nivel} data={data.ocorrencias} onChange={async () => { await this.load() }} {...this.props} />

            <ModalDm
              openModal={() => { this.toggleModal('openCustoAdicional') }}
              heading=" Inserir Orçamento "
              hiddenModal={() => { this.toggleModal('openCustoAdicional') }}
              openMd={openCustoAdicional}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    Adiciona a este pedido um orçamento.
                  </p>
                </div>
                <div className="bx--modal-content">
                  <div className="bx--row">
                    <div className="bx--col-md-8">
                      <TextInput
                        id="fonecedorOrcamento"
                        labelText="Fornecedor"
                        value={fonecedorOrcamento}
                        onChange={e => this.onChange(e)}
                        placeholder="ex: instalação"
                      />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-xs-8">
                      <label className="bx--label"> Valor </label>
                      <NumberFormat
                        getInputRef={ref => {
                          this.valorCustoOrcamentoRef = ref;
                        }}
                        id="valorCustoOrcamento"
                        className="bx--text-input bx--text__input"
                        fixedDecimalScale
                        decimalSeparator=","
                        prefix="R$ "
                        thousandSeparator="."
                        placeholder="R$ 0,00"
                        value={valorCustoOrcamento}
                        allowNegative={false}
                        decimalScale={2}
                        onValueChange={(values, e) => {
                          this.setState({
                            [e.target.id]: values.value ? Number(values.value) : null,
                            // isEdited: true,
                          });
                        }}
                        onFocus={() => {
                          if (!valorCustoOrcamento && this.valorCustoOrcamentoRef) {
                            this.valorCustoOrcamentoRef.value = '';
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      {!!idItem && (
                        <div className="f-left">
                          <button
                            className="bx--btn btn-primary-outlined h-sm-margin"
                            type="button"
                            onClick={() => { this.delete(idItem) }}
                          >
                            Deletar ocorrência
                          </button>
                        </div>
                      )}
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openCustoAdicional') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.saveOcorrencia()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>

            <ModalDm
              openModal={() => { this.toggleModal('openModalReprovar') }}
              heading="Reprovar"
              hiddenModal={() => { this.toggleModal('openModalReprovar') }}
              openMd={openModalReprovar}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    Você tem certeza que deseja Reprovar este pedido?
                  </p>
                </div>
                <div className="bx--modal-content">
                  <div className="bx--row">
                    <div className="bx--col-md-8">
                      <label>Nova data estimada</label>
                      <FormItem>
                        <DatePickerDm
                          id="novaDataEstimada"
                          name="novaDataEstimada"
                          placeholder="DD/MM/YYYY"
                          date={novaDataEstimada ? moment(novaDataEstimada) : ""}
                          locale="pt"
                          onDateChange={novaDataEstimada => this.onChangeDateTest(novaDataEstimada, "novaDataEstimada")}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalReprovar') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => {
                            await this.reprovarPedido()
                          }
                          }
                        >
                          Tenho certeza
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
            <div className={`modal-fluxo-agencia ${idStatus === Finalizado ? ' size-md-finalizar' : ''}`}>
              <ModalDm
                openModal={() => { this.toggleModal('openModalCancelar') }}
                heading={`${[FechamentoDeArquivo].indexOf(data.statusId) > -1 && nomeAcao === "Concluir" ? "Informe o local onde foi salvo o arquivo para concluir" : (nomeAcao === "Reprovação comercial" ? "Reprovar" : nomeAcao)}`}
                hiddenModal={() => { this.toggleModal('openModalCancelar') }}
                openMd={openModalCancelar}
              >
                <div>
                  <div className="bx--modal-header">
                    <p className="question">
                      {[FechamentoDeArquivo].indexOf(data.statusId) > -1 && nomeAcao === "Concluir" ? ""
                        : ((nomeAcao === "Reprovação comercial")
                          ? "Escreva o motivo da reprova do pedido"
                          : (nomeAcao === "Devolver"
                            ? "Escreva o motivo da devolução deste pedido"
                            : `Você tem certeza que deseja ${nomeAcao} este pedido?`))}
                    </p>
                  </div>
                  {(([FechamentoDeArquivo].indexOf(data.statusId) > -1) && nomeAcao === "Concluir") && (
                    <div className="bx--modal-content">
                      <div className="bx--row">
                        <div className="bx--col-md-12 bx--col-xs-12">
                          <p>Informe o local</p>
                          <TextArea
                            id="ocorrenciaFechamentoArquivo"
                            value={ocorrenciaFechamentoArquivo}
                            onChange={e => this.onChangeText(e)}
                            placeholder="Informe o local onde foi salvo o arquivo para concluir."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {(([Devolvido, Cancelado, Fornecedor, StatusCriacao, StatusRedacao].indexOf(idStatus) > -1) || ([DisponivelParaRetirada].indexOf(idStatus) > -1 && nomeAcao !== "Disponibilizar para retirada") ||
                    ([Triagem].indexOf(idStatus) > -1 && nivel === Criacao) || ([AprovacaoDeArte].indexOf(idStatus) > -1 && data.statusId === FechamentoDeArquivo) ||
                    (([FechamentoDeArquivo].indexOf(idStatus) > -1 && data.statusId !== AprovacaoDeArte) && [Consultor, Interno, Supervisor, Administrador].indexOf(nivel) > -1)) && (
                      <div className="bx--modal-content">
                        <div className="bx--row">
                          <div className="bx--col-md-12 bx--col-xs-12">
                            <TextArea
                              labelText=""
                              id="motivoDevolver"
                              value={motivoDevolver}
                              onChange={e => this.onChangeText(e)}
                              placeholder="Digite aqui o motivo"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  {([Finalizado].indexOf(idStatus) > -1) && (
                    <div className={([FechamentoDeArquivo].includes(data.statusId)) && this.isProdutoDigital() ? 'bx--modal-content ' : 'bx--modal-content content-calendar-show'}>
                      <div className="bx--row">
                        <div className="bx--col-md-12 bx--col-xs-12">
                          <FormItem>
                            <label>Dia da entrega</label>
                            <DatePickerDm
                              id="diaEntrega"
                              name="diaEntrega"
                              placeholder="DD/MM/YYYY"
                              date={diaEntrega ? moment(diaEntrega) : ""}
                              locale="pt"
                              onDateChange={diaEntrega => this.onChangeDateTest(diaEntrega, "diaEntrega")}
                              isOutsideRange={() => false}
                            />
                          </FormItem>
                        </div>
                      </div>
                    </div>
                  )}
                  {(([FechamentoDeArquivo].includes(data.statusId)) && idStatus === Finalizado && this.isProdutoDigital()) && (
                    <div className="bx--row">
                      <div className="bx--col-md-12 bx--col-xs-12">
                        <p>Quem recebeu</p>
                        <TextInput
                          id="responsavelRecebimento"
                          value={responsavelRecebimento}
                          onChange={e => this.onChangeText(e)}
                          placeholder="Quem recebeu"
                        />
                      </div>
                    </div>
                  )}
                  {(([FechamentoDeArquivo].includes(data.statusId)) && idStatus === Finalizado && this.isProdutoDigital()) && (
                    <div className="bx--modal-content">
                      <div className="bx--row">
                        <div className="bx--col-md-12 bx--col-xs-12">
                          <p>Caminho do arquivo</p>
                          <TextArea
                            id="ocorrenciaFechamentoArquivo"
                            value={ocorrenciaFechamentoArquivo}
                            onChange={e => this.onChangeText(e)}
                            placeholder="Informe o local onde foi salvo o arquivo para concluir."
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="bx--modal-footer">
                    <div className="bx--row btn-actions">
                      <div className="bx--col-md-12 bx--col-xs-12">
                        <div className="f-right">
                          <button
                            className="bx--btn btn-secondary-outlined h-sm-margin"
                            type="button"
                            onClick={() => { this.toggleModal('openModalCancelar') }}
                          >
                            Cancelar
                          </button>
                          <button
                            className="bx--btn btn-secondary-color h-sm-margin"
                            type="button"
                            onClick={async () => { await this.trocaStatus() }}
                          >
                            Tenho certeza
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalDm>
            </div>

            <ModalDm
              openModal={() => { this.toggleModal('openModalEmTransporte') }}
              heading="Atualizar para 'Em transporte'"
              hiddenModal={() => { this.toggleModal('openModalEmTransporte') }}
              openMd={openModalEmTransporte}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    Você tem certeza que deseja Atualizar para `Em transporte` este pedido?
                  </p>
                </div>
                <div className="bx--modal-content">
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <FormItem>
                        <label>Data de chegada</label>
                        <DatePickerDm
                          id="diaEntrega"
                          name="diaEntrega"
                          placeholder="DD/MM/YYYY"
                          date={diaEntrega ? moment(diaEntrega) : ""}
                          locale="pt"
                          // eslint-disable-next-line no-shadow
                          onDateChange={diaEntrega => this.onChangeDateTest(diaEntrega, "diaEntrega")}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <TextInput
                        labelText="Nome da Transportadora"
                        id="nomeTransportadora"
                        value={nomeTransportadora}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Nome da transportadora"
                      />
                    </div>
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalEmTransporte') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => {
                            await this.trocaStatusTransporte()
                          }
                          }
                        >
                          Tenho certeza
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
            <ModalDm
              openModal={() => { this.toggleModal('openModalFinalizarPedido') }}
              heading="Atualizar para 'Entregue'"
              hiddenModal={() => { this.toggleModal('openModalFinalizarPedido') }}
              openMd={openModalFinalizarPedido}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    {statusId !== EmTransporte && (<React.Fragment>Você tem certeza que deseja definir este pedido como entregue?</React.Fragment>)}
                    {[FechamentoDeArquivo, EmTransporte].includes(statusId) && (<React.Fragment>Informe para quem foi enviado o arquivo.</React.Fragment>)}
                  </p>
                </div>

                <div className="bx--modal-content">
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <FormItem>
                        <label>Data da entrega</label>
                        <DatePickerDm
                          id="diaEntrega"
                          name="diaEntrega"
                          placeholder="DD/MM/YYYY"
                          date={diaEntrega ? moment(diaEntrega) : ""}
                          locale="pt"
                          onDateChange={diaEntrega => this.onChangeDateTest(diaEntrega, "diaEntrega")}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <label>Quem recebeu</label>
                      <TextInput
                        id="responsavelRecebimento"
                        value={responsavelRecebimento}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Quem recebeu"
                      />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <TextInput
                        labelText="Quem entregou"
                        id="responsavelEntrega"
                        value={responsavelEntrega}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Quem entregou"
                      />
                    </div>
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalFinalizarPedido') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => {
                            await this.trocaStatusPedidoEntregue()
                          }}
                        >
                          Tenho certeza
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
            <ModalDm
              openModal={() => { this.toggleModal('openModalResponsavel') }}
              heading="Delegar para Designer"
              hiddenModal={() => { this.toggleModal('openModalResponsavel') }}
              openMd={openModalResponsavel}
            >
              <div>
                <div className="bx--modal-content" style={{ minHeight: "270px" }}>
                  <div className="bx--row">
                    <div className="bx--col-md-8">
                      <FormItem className="v-sm-margin">
                        <label>Data estimada</label>
                        <DatePickerDm
                          id="dataEstimada"
                          name="dataEstimada"
                          placeholder="DD/MM/YYYY"
                          date={dataEstimada ? moment(dataEstimada) : ""}
                          locale="pt"
                          onDateChange={dataEstimada => this.onChangeDateTest(dataEstimada, "dataEstimada")}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="bx--row" style={{ marginTop: "20px" }}>
                    <div className="bx--col-xs-8">
                      <label>Designer</label>
                      <Select
                        className="search-dm"
                        name="idDesigner"
                        options={listDesigners}
                        value={idDesigner}
                        onChange={this.onChangeDesigner}
                        placeholder="Responsável"
                        isClearable={false}
                        isSearchable
                      />
                    </div>
                  </div>
                  <div className="bx--row" style={{ marginTop: "20px" }}>
                    <div className="bx--col-xs-8">
                      <label>Redatora</label>
                      <Select
                        className="search-dm"
                        name="Redatora"
                        options={listRedatora}
                        value={isRedatora}
                        onChange={this.onChangeRedatora}
                        placeholder="Selecione uma opção"
                        isClearable={false}
                        isSearchable
                      />
                    </div>
                  </div>

                  <div className="bx--row" style={{ marginTop: "20px" }}>
                    <div className="bx--col-xs-8">
                      <label>Prioridade</label>
                      <Select
                        className="search-dm"
                        name="Prioridade"
                        options={[
                          { id: 1, label: "Sim" },
                          { id: 0, label: "Não" }
                        ]}
                        value={isPrioridade}
                        onChange={option => {
                          // Transforma a resposta em Alto/Baixo conforme o valor selecionado
                          const prioridade = option.id === 1
                            ? { id: 1, label: "Alto" }
                            : { id: 0, label: "Baixo" };
                          this.onChangePrioridade(prioridade);
                        }}
                        placeholder="Selecione uma opção"
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalResponsavel') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.delegaDesigner()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
            <ModalDm
              openModal={() => { this.toggleModal('openModalNovaDataDesejada') }}
              heading="Nova Data Desejada"
              hiddenModal={() => { this.toggleModal('openModalNovaDataDesejada') }}
              openMd={openModalNovaDataDesejada}
            >
              <div>
                <div className="bx--modal-content" style={{ minHeight: "270px" }}>
                  <div className="bx--row">
                    <div className="bx--col-md-8">
                      <FormItem className="v-sm-margin">
                        <label>Data desejada</label>
                        <DatePickerDm
                          id="novaDataDesejada"
                          name="novaDataDesejada"
                          placeholder="DD/MM/YYYY"
                          date={novaDataDesejada ? moment(novaDataDesejada) : ""}
                          locale="pt"
                          onDateChange={novaDataDesejada => this.onChangeDateTest(novaDataDesejada, "novaDataDesejada")}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                  </div>
                  
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalNovaDataDesejada') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.salvaNovaData()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>

            <ModalDm
              openModal={() => { this.toggleModal('openTrocaDeStatus') }}
              heading="Status do Item"
              hiddenModal={() => { this.toggleModal('openTrocaDeStatus') }}
              openMd={openTrocaDeStatus}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    Selecione um novo status para este item.
                  </p>
                </div>
                <div className="bx--modal-content">
                  {[DisponivelParaRetirada, EmTransporte].indexOf(data.statusId) > -1 && (
                    <div className="bx--row">
                      <div className="bx--col-md-8">
                        <FormItem>
                          <RadioButton
                            name="status"
                            onChange={this.onChangeStatusItem}
                            checked={idStatusItem === 25}
                            value={25}
                            labelText="Pedido Entregue"
                          />
                        </FormItem>
                      </div>
                    </div>
                  )}
                  {[DisponivelParaRetirada, EmTransporte].indexOf(data.statusId) > -1 && (
                    <div className="bx--row">
                      <div className="bx--col-md-8">
                        <FormItem>
                          <RadioButton
                            name="status"
                            onChange={this.onChangeStatusItem}
                            checked={idStatusItem === 22}
                            value={22}
                            labelText="Retorna fornecedor"
                          />
                        </FormItem>
                      </div>
                    </div>
                  )}
                  {[Fornecedor].indexOf(data.statusId) > -1 && (
                    <div className="bx--row">
                      <div className="bx--col-md-8">
                        <FormItem>
                          <RadioButton
                            name="status"
                            onChange={this.onChangeStatusItem}
                            checked={idStatusItem === 24}
                            value={24}
                            labelText="Em transporte"
                          />
                        </FormItem>
                      </div>
                    </div>
                  )}
                  {[Fornecedor].indexOf(data.statusId) > -1 && (
                    <div className="bx--row">
                      <div className="bx--col-md-8">
                        <FormItem>
                          <RadioButton
                            name="status"
                            onChange={this.onChangeStatusItem}
                            checked={idStatusItem === 23}
                            value={23}
                            labelText="Disponível para retirada"
                          />
                        </FormItem>
                      </div>
                    </div>
                  )}
                  {exibeDescricao && (
                    <div className="bx--row">
                      <div className="bx--col-md-12 bx--col-xs-12">
                        <TextArea
                          labelText=""
                          id="motivoDevolverItem"
                          value={motivoDevolverItem}
                          onChange={e => this.onChangeText(e)}
                          placeholder="Digite aqui o motivo"
                        />
                      </div>
                    </div>
                  )}
                  {exibirdataStatusItem && (
                    <div className="bx--row">
                      <div className="bx--col-md-8">
                        <FormItem>
                          <DatePickerDm
                            id="dataStatusItem"
                            name="dataStatusItem"
                            placeholder="DD/MM/YYYY"
                            date={dataStatusItem ? moment(dataStatusItem) : ""}
                            locale="pt"
                            // eslint-disable-next-line no-unused-vars
                            onDateChange={dataStatusItem => this.onChangeDateTest(dataEstimada, "dataStatusItem")}
                            isOutsideRange={() => false}
                            readOnly
                          />
                        </FormItem>
                      </div>
                    </div>
                  )}
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openTrocaDeStatus') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.saveStatusItem()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
            <ModalDm
              openModal={() => { this.toggleModal('openModalFornecedor') }}
              heading="Selecionar Fornecedor"
              hiddenModal={() => { this.toggleModal('openModalFornecedor') }}
              openMd={openModalFornecedor}
            >
              <div>
                <div className="bx--modal-header">
                  <p className="question">
                    Selecione o
                    <strong>
                      &nbsp;fornecedor&nbsp;
                    </strong>
                    que produzirá as artes.
                  </p>
                </div>
                <div className="bx--modal-content">
                  <div className="bx--row">
                    <div className="bx--col-md-8">
                      <label>Data Prevista Pedido</label>
                      <FormItem>
                        <DatePickerDm
                          id="dataEstimativaEntrega"
                          name="dataEstimativaEntrega"
                          placeholder="DD/MM/YYYY"
                          date={dataEstimativaEntrega ? moment(dataEstimativaEntrega) : ""}
                          locale="pt"
                          onDateChange={dataEstimativaEntrega => this.onChangeDateTest(dataEstimativaEntrega, "dataEstimativaEntrega")}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-4">
                      <FormItem className="select-full-width">
                        <label>UF</label>
                        <Select
                          className="search-dm"
                          name="estadoId"
                          options={estados}
                          value={estadoId}
                          onChange={this.onChangeEstado}
                          placeholder="UF"
                          isClearable={false}
                          isSearchable
                        />
                      </FormItem>
                    </div>
                    <div className="bx--col-md-8">
                      <label>Cidade</label>
                      <FormItem className="select-full-width">
                        <Select
                          className="search-dm"
                          name="cidadeId"
                          options={cidades}
                          value={cidadeId}
                          onChange={this.onChangeCidade}
                          placeholder="Cidade"
                          isClearable={false}
                          isSearchable
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <FormItem className="select-full-width">
                        <SearchInput onChange={this.onSearchChange} value={search} placeholder="Buscar por nome" />
                      </FormItem>
                    </div>
                  </div>
                  {fornecedores && fornecedores.map(item => (
                    <div className="bx--row" key={`k${item.id}`}>
                      <div className="bx--col-md-12">
                        <FormItem>
                          <RadioButton
                            name="fornecedor"
                            onChange={this.onChangeFornecedor}
                            checked={idFornecedor === item.id}
                            value={item.id}
                            labelText={item.nomeFantasia}
                          />
                        </FormItem>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.toggleModal('openModalFornecedor') }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.delegaFornecedor()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ModalDm>
            <div className="wide-modal">
              <ModalDm
                openModal={() => { this.toggleModal('modalLojas') }}
                heading="Lojas"
                hiddenModal={() => { this.toggleModal('modalLojas') }}
                openMd={modalLojas}
              >
                <div>
                  <div className="bx--modal-content">
                    {(data.unidades && data.unidades.map(item => (
                      <p>{`${item.unidade.nome} - ${item.loja.nome}`}</p>
                    )))}
                  </div>
                  <div className="bx--modal-footer">
                    <div className="bx--row btn-actions">
                      <div className="bx--col-md-12 bx--col-xs-12">
                        <div className="f-right">
                          <button
                            className="bx--btn btn-secondary-color h-sm-margin"
                            type="button"
                            onClick={async () => this.toggleModal('modalLojas')}
                          >
                            Fechar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalDm>
            </div>
            <div>
              <Modal
                open={openMdOrcar}
                onRequestSubmit={() => this.insertBudgetValue()}
                onRequestClose={() => this.openModalOrcar()}
                modalHeading="Orçar Produto"
                primaryButtonText="Salvar"
                secondaryButtonText="Cancelar"
              >
                <div className="bx--row">
                  <div className="bx--col-md-12 bx--col-xs-12 bx--col-sm-12">
                    <label className="bx--label">
                      {`Preço para este produto por ${nomeUnidadeMedida}.`}
                    </label>
                    <NumberFormat
                      getInputRef={ref => {
                        this.valorOrcamentoRef = ref;
                      }}
                      id="valorOrcamento"
                      className="bx--text-input bx--text__input"
                      fixedDecimalScale
                      decimalSeparator=","
                      prefix="R$ "
                      thousandSeparator="."
                      placeholder="R$ 0,00"
                      value={valorOrcamento}
                      allowNegative={false}
                      decimalScale={2}
                      onValueChange={(values, e) => {
                        this.setState({
                          [e.target.id]: values.value ? Number(values.value) : null,
                          // isEdited: true,
                        });
                      }}
                      onFocus={() => {
                        if (!valorOrcamento && this.valorOrcamento) {
                          this.valorOrcamento.value = '';
                        }
                      }}
                    />
                  </div>
                </div>
              </Modal>
              <Modal
                open={openMdDelete}
                onRequestSubmit={() => this.deletarItemPedido()}
                onRequestClose={() => this.openModalDeletar()}
                modalHeading="Deletar Item"
                primaryButtonText="Deletar"
                secondaryButtonText="Cancelar"
              >
                <div className="bx--modal-header">
                  <p className="question">
                    Você tem certeza que deseja deletar este item?
                  </p>
                </div>
                <div className="bx--modal-content">
                  <div className="bx--row">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <TextArea
                        labelText=""
                        id="motivoExcluir"
                        value={motivoExcluir}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Digite aqui o motivo"
                      />
                    </div>
                  </div>
                </div>
              </Modal>

              <ModalDm
                openModal={this.openDesignarEquipe}
                heading="Selecione a Equipe"
                hiddenModal={this.openDesignarEquipe}
                openMd={openMdEquipe}
              >
                <div>
                  <div className="bx--modal-content" style={{ maxHeight: 360 }}>
                    <div className="bx--row">
                      <div className="bx--col-md-12">
                        <RadioButton
                          name="equipe"
                          labelText="Nenhuma"
                          checked={idEquipe === 0}
                          onClick={() => this.onChangeCheckEquipe(0)}
                        />
                      </div>
                    </div>
                    {equipes.map(equipe => (
                      <div className="bx--row">
                        <div className="bx--col-xs-12" style={{ marginTop: 10 }}>
                          <RadioButton
                            name="equipe"
                            checked={idEquipe === equipe.id}
                            labelText={equipe.nome}
                            onClick={() => this.onChangeCheckEquipe(equipe.id)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={this.openDesignarEquipe}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.delegaEquipe()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalDm>

              <ModalDm
                openModal={this.openDesignarSolicitante}
                heading="Selecione o Solicitante"
                hiddenModal={this.openDesignarSolicitante}
                openMd={openMdSolicitante}
              >
                <div>
                  <div className="bx--modal-content">
                    <div className="bx--row">
                      <div className="bx--col-md-12">
                        <FormItem className="select-full-width">
                          <SearchInput onChange={this.onSearchSolicitanteChange} value={searchSolicitante} placeholder="Buscar por nome" />
                        </FormItem>
                      </div>
                    </div>
                    <div style={{ maxHeight: 360, overflow: "auto" }}>
                      {solicitantes && solicitantes.map(item => (
                        <div className="bx--row" key={`k${item.id}`} style={{ marginTop: 10 }}>
                          <div className="bx--col-md-12">
                            <FormItem>
                              <RadioButton
                                name="fornecedor"
                                onChange={() => { this.onChangeSolicitante(item.id) }}
                                checked={idSolicitante === item.id}
                                value={item.id}
                                labelText={item.nome}
                              />
                            </FormItem>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="bx--modal-footer">
                    <div className="bx--row btn-actions">
                      <div className="bx--col-md-12 bx--col-xs-12">
                        <div className="f-right">
                          <button
                            className="bx--btn btn-secondary-outlined h-sm-margin"
                            type="button"
                            onClick={this.openDesignarSolicitante}
                          >
                            Cancelar
                          </button>
                          <button
                            className="bx--btn btn-secondary-color h-sm-margin"
                            type="button"
                            onClick={async () => this.delegaSolicitante()}
                            disabled={idSolicitante === 0}
                          >
                            Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalDm>

              <ModalDm
                openModal={() => { this.openModalRating() }}
                heading="Deixe sua avaliação para este pedido"
                hiddenModal={() => { this.closeModalRating() }}
                openMd={openRatingModal}
                className="modal-avaliacao"
              >
                <div className="bx--modal-content modal-avaliacao-content">
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <h4>
                        <b>Criação (arte)</b>
                      </h4>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <StarRatings
                        rating={notaCriacao}
                        starRatedColor="#dab600"
                        numberOfStars={5}
                        name='notaCriacao'
                        starDimension="35px"
                        starHoverColor="#dab600"
                        starSpacing="5px"
                        changeRating={this.changeRating}
                      />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-xs-12">
                      <label className="bx--label"> Comentário </label>
                      <TextArea
                        labelText=""
                        id="notaCriacaoComentario"
                        value={notaCriacaoComentario}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Informe o comentário."
                        rows={1}
                      />
                    </div>
                  </div>
                </div>

                <div className="bx--modal-content modal-avaliacao-content">
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <h4>
                        <b>Material</b>
                      </h4>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <StarRatings
                        rating={notaMaterial}
                        starRatedColor="#dab600"
                        numberOfStars={5}
                        name='notaMaterial'
                        starDimension="35px"
                        starHoverColor="#dab600"
                        starSpacing="5px"
                        changeRating={this.changeRating}
                      />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-xs-12">
                      <label className="bx--label"> Comentário </label>
                      <TextArea
                        labelText=""
                        id="notaMaterialComentario"
                        value={notaMaterialComentario}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Informe o comentário."
                        rows={1}
                      />
                    </div>
                  </div>
                </div>

                <div className="bx--modal-content modal-avaliacao-content">
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <h4>
                        <b>Atendimento</b>
                      </h4>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-md-12">
                      <StarRatings
                        rating={notaAtendimento}
                        starRatedColor="#dab600"
                        numberOfStars={5}
                        name='notaAtendimento'
                        starDimension="35px"
                        starHoverColor="#dab600"
                        starSpacing="5px"
                        changeRating={this.changeRating}
                      />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-xs-12">
                      <label className="bx--label"> Comentário </label>
                      <TextArea
                        labelText=""
                        id="notaAtendimentoComentario"
                        value={notaAtendimentoComentario}
                        onChange={e => this.onChangeText(e)}
                        placeholder="Informe o comentário."
                        rows={1}
                      />
                    </div>
                  </div>
                </div>

                <div className="bx--modal-footer">
                  <div className="bx--row btn-actions">
                    <div className="bx--col-md-12 bx--col-xs-12">
                      <div className="f-right">
                        <button
                          className="bx--btn btn-secondary-outlined h-sm-margin"
                          type="button"
                          onClick={() => { this.closeModalRating() }}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color h-sm-margin"
                          type="button"
                          onClick={async () => this.saveRating()}
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalDm>

              <ModalLogistica
                logistica={logistica}
                isOpen={openModalLogistica}
                modal="openModalLogistica"
                toggleModal={this.toggleModal}
                pedido={data.id}
                load={this.load}
              />

              <ModalConfirmacao
                isOpen={openModalConfirmacao}
                modal="openModalConfirmacao"
                toggleModal={this.toggleModal}
                newStatus={newStatusModalConfirmacao}
                pedido={data.id}
              />

              <ModalDm
                openModal={() => { this.toggleModal('openTracking') }}
                heading=" Rastreio "
                hiddenModal={() => { this.toggleModal('openTracking') }}
                openMd={openTracking}
              >
                <div>
                  <div className="bx--modal-header">
                    <p className="question">
                      Adiciona a este pedido um código de rastreio.
                    </p>
                  </div>
                  <div className="bx--modal-content">
                    <div className="bx--row">
                      <div className="bx--col-md-8">
                        <TextInput
                          id="codigoRastreio"
                          labelText="Código Rastreio"
                          value={codigoRastreio}
                          onChange={e => this.onChange(e)}                        
                        />
                      </div>
                    </div>                  
                  </div>
                  <div className="bx--modal-footer">
                    <div className="bx--row btn-actions">
                      <div className="bx--col-md-12 bx--col-xs-12">                      
                        <div className="f-right">
                          <button
                            className="bx--btn btn-secondary-outlined h-sm-margin"
                            type="button"
                            onClick={() => { this.toggleModal('openTracking') }}
                          >
                            Cancelar
                          </button>
                          <button
                            className="bx--btn btn-secondary-color h-sm-margin"
                            type="button"
                            onClick={async () => this.saveTracking()}
                          >
                            Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalDm>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default DetailRequestAgency;



// WEBPACK FOOTER //
// ./src/components/agency/requests/DetailRequestAgency.js